/* Bootstrap v3.3.5 (https://getbootstrap.com)
 Copyright 2011-2015 Twitter, Inc.
 Licensed under the MIT license
*/
(function() {
  function b(e, d) {
    function c(e, d) {
      return function() {
        return e.apply(d, arguments)
      }
    }
    d = d || {};
    this.trackingClick = !1;
    this.trackingClickStart = 0;
    this.targetElement = null;
    this.lastTouchIdentifier = this.touchStartY = this.touchStartX = 0;
    this.touchBoundary = d.touchBoundary || 10;
    this.layer = e;
    this.tapDelay = d.tapDelay || 200;
    this.tapTimeout = d.tapTimeout || 700;
    if (!b.notNeeded(e)) {
      d = "onMouse onClick onTouchStart onTouchMove onTouchEnd onTouchCancel".split(" ");
      for (var f = 0, l = d.length; f < l; f++) this[d[f]] = c(this[d[f]],
        this);
      h && (e.addEventListener("mouseover", this.onMouse, !0), e.addEventListener("mousedown", this.onMouse, !0), e.addEventListener("mouseup", this.onMouse, !0));
      e.addEventListener("click", this.onClick, !0);
      e.addEventListener("touchstart", this.onTouchStart, !1);
      e.addEventListener("touchmove", this.onTouchMove, !1);
      e.addEventListener("touchend", this.onTouchEnd, !1);
      e.addEventListener("touchcancel", this.onTouchCancel, !1);
      Event.prototype.stopImmediatePropagation || (e.removeEventListener = function(d, b, c) {
        var f = Node.prototype.removeEventListener;
        "click" === d ? f.call(e, d, b.hijacked || b, c) : f.call(e, d, b, c)
      }, e.addEventListener = function(d, b, c) {
        var f = Node.prototype.addEventListener;
        "click" === d ? f.call(e, d, b.hijacked || (b.hijacked = function(e) {
          e.propagationStopped || b(e)
        }), c) : f.call(e, d, b, c)
      });
      if ("function" === typeof e.onclick) {
        var g = e.onclick;
        e.addEventListener("click", function(e) {
          g(e)
        }, !1);
        e.onclick = null
      }
    }
  }
  var g = 0 <= navigator.userAgent.indexOf("Windows Phone"),
    h = 0 < navigator.userAgent.indexOf("Android") && !g,
    f = /iP(ad|hone|od)/.test(navigator.userAgent) &&
    !g,
    c = f && /OS 4_\d(_\d)?/.test(navigator.userAgent),
    d = f && /OS ([6-9]|\d{2})_\d/.test(navigator.userAgent),
    l = 0 < navigator.userAgent.indexOf("BB10");
  b.prototype.needsClick = function(e) {
    switch (e.nodeName.toLowerCase()) {
      case "button":
      case "select":
      case "textarea":
        if (e.disabled) return !0;
        break;
      case "input":
        if (f && "file" === e.type || e.disabled) return !0;
        break;
      case "label":
      case "iframe":
      case "video":
        return !0
    }
    return /\bneedsclick\b/.test(e.className)
  };
  b.prototype.needsFocus = function(e) {
    switch (e.nodeName.toLowerCase()) {
      case "textarea":
        return !0;
      case "select":
        return !h;
      case "input":
        switch (e.type) {
          case "button":
          case "checkbox":
          case "file":
          case "image":
          case "radio":
          case "submit":
            return !1
        }
        return !e.disabled && !e.readOnly;
      default:
        return /\bneedsfocus\b/.test(e.className)
    }
  };
  b.prototype.sendClick = function(e, d) {
    document.activeElement && document.activeElement !== e && document.activeElement.blur();
    var b = d.changedTouches[0];
    d = document.createEvent("MouseEvents");
    d.initMouseEvent(this.determineEventType(e), !0, !0, window, 1, b.screenX, b.screenY, b.clientX, b.clientY,
      !1, !1, !1, !1, 0, null);
    d.forwardedTouchEvent = !0;
    e.dispatchEvent(d)
  };
  b.prototype.determineEventType = function(e) {
    return h && "select" === e.tagName.toLowerCase() ? "mousedown" : "click"
  };
  b.prototype.focus = function(e) {
    if (f && e.setSelectionRange && 0 !== e.type.indexOf("date") && "time" !== e.type && "month" !== e.type) {
      var d = e.value.length;
      e.setSelectionRange(d, d)
    } else e.focus()
  };
  b.prototype.updateScrollParent = function(e) {
    var d = e.fastClickScrollParent;
    if (!d || !d.contains(e)) {
      var b = e;
      do {
        if (b.scrollHeight > b.offsetHeight) {
          d = b;
          e.fastClickScrollParent = b;
          break
        }
        b = b.parentElement
      } while (b)
    }
    d && (d.fastClickLastScrollTop = d.scrollTop)
  };
  b.prototype.getTargetElementFromEventTarget = function(e) {
    return e.nodeType === Node.TEXT_NODE ? e.parentNode : e
  };
  b.prototype.onTouchStart = function(e) {
    if (1 < e.targetTouches.length) return !0;
    var d = this.getTargetElementFromEventTarget(e.target);
    var b = e.targetTouches[0];
    if (f) {
      var l = window.getSelection();
      if (l.rangeCount && !l.isCollapsed) return !0;
      if (!c) {
        if (b.identifier && b.identifier === this.lastTouchIdentifier) return e.preventDefault(),
          !1;
        this.lastTouchIdentifier = b.identifier;
        this.updateScrollParent(d)
      }
    }
    this.trackingClick = !0;
    this.trackingClickStart = e.timeStamp;
    this.targetElement = d;
    this.touchStartX = b.pageX;
    this.touchStartY = b.pageY;
    e.timeStamp - this.lastClickTime < this.tapDelay && e.preventDefault();
    return !0
  };
  b.prototype.touchHasMoved = function(e) {
    e = e.changedTouches[0];
    var d = this.touchBoundary;
    return Math.abs(e.pageX - this.touchStartX) > d || Math.abs(e.pageY - this.touchStartY) > d ? !0 : !1
  };
  b.prototype.onTouchMove = function(e) {
    if (!this.trackingClick) return !0;
    if (this.targetElement !== this.getTargetElementFromEventTarget(e.target) || this.touchHasMoved(e)) this.trackingClick = !1, this.targetElement = null;
    return !0
  };
  b.prototype.findControl = function(e) {
    return void 0 !== e.control ? e.control : e.htmlFor ? document.getElementById(e.htmlFor) : e.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")
  };
  b.prototype.onTouchEnd = function(e) {
    var b = this.targetElement;
    if (!this.trackingClick) return !0;
    if (e.timeStamp - this.lastClickTime < this.tapDelay) return this.cancelNextClick = !0;
    if (e.timeStamp - this.trackingClickStart > this.tapTimeout) return !0;
    this.cancelNextClick = !1;
    this.lastClickTime = e.timeStamp;
    var l = this.trackingClickStart;
    this.trackingClick = !1;
    this.trackingClickStart = 0;
    if (d) {
      var g = e.changedTouches[0];
      b = document.elementFromPoint(g.pageX - window.pageXOffset, g.pageY - window.pageYOffset) || b;
      b.fastClickScrollParent = this.targetElement.fastClickScrollParent
    }
    g = b.tagName.toLowerCase();
    if ("label" === g) {
      if (l = this.findControl(b)) {
        this.focus(b);
        if (h) return !1;
        b = l
      }
    } else if (this.needsFocus(b)) {
      if (100 <
        e.timeStamp - l || f && window.top !== window && "input" === g) return this.targetElement = null, !1;
      this.focus(b);
      this.sendClick(b, e);
      f && "select" === g || (this.targetElement = null, e.preventDefault());
      return !1
    }
    if (f && !c && (l = b.fastClickScrollParent) && l.fastClickLastScrollTop !== l.scrollTop) return !0;
    this.needsClick(b) || (e.preventDefault(), this.sendClick(b, e));
    return !1
  };
  b.prototype.onTouchCancel = function() {
    this.trackingClick = !1;
    this.targetElement = null
  };
  b.prototype.onMouse = function(e) {
    return this.targetElement && !e.forwardedTouchEvent &&
      e.cancelable ? !this.needsClick(this.targetElement) || this.cancelNextClick ? (e.stopImmediatePropagation ? e.stopImmediatePropagation() : e.propagationStopped = !0, e.stopPropagation(), e.preventDefault(), !1) : !0 : !0
  };
  b.prototype.onClick = function(e) {
    if (this.trackingClick) return this.targetElement = null, this.trackingClick = !1, !0;
    if ("submit" === e.target.type && 0 === e.detail) return !0;
    e = this.onMouse(e);
    e || (this.targetElement = null);
    return e
  };
  b.prototype.destroy = function() {
    var e = this.layer;
    h && (e.removeEventListener("mouseover",
      this.onMouse, !0), e.removeEventListener("mousedown", this.onMouse, !0), e.removeEventListener("mouseup", this.onMouse, !0));
    e.removeEventListener("click", this.onClick, !0);
    e.removeEventListener("touchstart", this.onTouchStart, !1);
    e.removeEventListener("touchmove", this.onTouchMove, !1);
    e.removeEventListener("touchend", this.onTouchEnd, !1);
    e.removeEventListener("touchcancel", this.onTouchCancel, !1)
  };
  b.notNeeded = function(e) {
    var b, d;
    if ("undefined" === typeof window.ontouchstart) return !0;
    if (d = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1])
      if (h) {
        if ((b = document.querySelector("meta[name=viewport]")) && (-1 !== b.content.indexOf("user-scalable=no") || 31 < d && document.documentElement.scrollWidth <= window.outerWidth)) return !0
      } else return !0;
    return l && (b = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/), 10 <= b[1] && 3 <= b[2] && (b = document.querySelector("meta[name=viewport]")) && (-1 !== b.content.indexOf("user-scalable=no") || document.documentElement.scrollWidth <= window.outerWidth)) ? !0 : "none" === e.style.msTouchAction || "none" === e.style.touchAction ?
      !0 : !1
  };
  b.attach = function(e, d) {
    return new b(e, d)
  };
  "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
    return b
  }) : "undefined" !== typeof module && module.exports ? (module.exports = b.attach, module.exports.FastClick = b) : window.FastClick = b
})();
/* ============================================================
   BOOTSTRAP CORE / TRANSITION SUPPORT
   STATUS: KEEP TEMPORARILY
   REASON: Required by Bootstrap modules while main.patch.js is still active.
   ============================================================ */
if ("undefined" == typeof jQuery) throw Error("Bootstrap's JavaScript requires jQuery"); +
function(b) {
  b = b.fn.jquery.split(" ")[0].split(".");
  if (2 > b[0] && 9 > b[1] || 1 == b[0] && 9 == b[1] && 1 > b[2]) throw Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher");
}(jQuery); +
function(b) {
  function g() {
    var b = document.createElement("bootstrap"),
      f = {
        WebkitTransition: "webkitTransitionEnd",
        MozTransition: "transitionend",
        OTransition: "oTransitionEnd otransitionend",
        transition: "transitionend"
      },
      c;
    for (c in f)
      if (void 0 !== b.style[c]) return {
        end: f[c]
      };
    return !1
  }
  b.fn.emulateTransitionEnd = function(h) {
    var f = !1,
      c = this;
    b(this).one("bsTransitionEnd", function() {
      f = !0
    });
    return setTimeout(function() {
      f || b(c).trigger(b.support.transition.end)
    }, h), this
  };
  b(function() {
    b.support.transition = g();
    b.support.transition &&
      (b.event.special.bsTransitionEnd = {
        bindType: b.support.transition.end,
        delegateType: b.support.transition.end,
        handle: function(h) {
          return b(h.target).is(this) ? h.handleObj.handler.apply(this, arguments) : void 0
        }
      })
  })
}(jQuery); +

/* ============================================================
   BOOTSTRAP COLLAPSE
   STATUS: PARTIALLY REPLACED
   PURPOSE:
   Provides expandable/collapsible content sections.
   USED BY BEDZ KING:
   Yes
   ACTION:
   Footer navigation replaced by main.v2.02.js.
   Review remaining uses before removing this module.
   ============================================================ */

function(b) {
  function g(d) {
    var c;
    d = d.attr("data-target") || (c = d.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");
    return b(d)
  }

  function h(d) {
    return this.each(function() {
      var c = b(this),
        e = c.data("bs.collapse"),
        g = b.extend({}, f.DEFAULTS, c.data(), "object" == typeof d && d);
      !e && g.toggle && /show|hide/.test(d) && (g.toggle = !1);
      e || c.data("bs.collapse", e = new f(this, g));
      "string" == typeof d && e[d]()
    })
  }
  var f = function(d, c) {
    this.$element = b(d);
    this.options = b.extend({}, f.DEFAULTS, c);
    this.$trigger = b('[data-toggle="collapse"][href="#' +
      d.id + '"],[data-toggle="collapse"][data-target="#' + d.id + '"]');
    this.transitioning = null;
    this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger);
    this.options.toggle && this.toggle()
  };
  f.VERSION = "3.3.5";
  f.TRANSITION_DURATION = 350;
  f.DEFAULTS = {
    toggle: !0
  };
  f.prototype.dimension = function() {
    return this.$element.hasClass("width") ? "width" : "height"
  };
  f.prototype.show = function() {
    if (!this.transitioning && !this.$element.hasClass("in")) {
      var d, c = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
      if (!(c && c.length && (d = c.data("bs.collapse"), d && d.transitioning))) {
        var e = b.Event("show.bs.collapse");
        if (this.$element.trigger(e), !e.isDefaultPrevented()) {
          c && c.length && (h.call(c, "hide"), d || c.data("bs.collapse", null));
          var g = this.dimension();
          this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0);
          this.$trigger.removeClass("collapsed").attr("aria-expanded", !0);
          this.transitioning = 1;
          d = function() {
            this.$element.removeClass("collapsing").addClass("collapse in")[g]("");
            this.transitioning =
              0;
            this.$element.trigger("shown.bs.collapse")
          };
          if (!b.support.transition) return d.call(this);
          c = b.camelCase(["scroll", g].join("-"));
          this.$element.one("bsTransitionEnd", b.proxy(d, this)).emulateTransitionEnd(f.TRANSITION_DURATION)[g](this.$element[0][c])
        }
      }
    }
  };
  f.prototype.hide = function() {
    if (!this.transitioning && this.$element.hasClass("in")) {
      var c = b.Event("hide.bs.collapse");
      if (this.$element.trigger(c), !c.isDefaultPrevented()) {
        c = this.dimension();
        this.$element[c](this.$element[c]())[0].offsetHeight;
        this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",
          !1);
        this.$trigger.addClass("collapsed").attr("aria-expanded", !1);
        this.transitioning = 1;
        var g = function() {
          this.transitioning = 0;
          this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
        };
        return b.support.transition ? void this.$element[c](0).one("bsTransitionEnd", b.proxy(g, this)).emulateTransitionEnd(f.TRANSITION_DURATION) : g.call(this)
      }
    }
  };
  f.prototype.toggle = function() {
    this[this.$element.hasClass("in") ? "hide" : "show"]()
  };
  f.prototype.getParent = function() {
    return b(this.options.parent).find('[data-toggle="collapse"][data-parent="' +
      this.options.parent + '"]').each(b.proxy(function(c, f) {
      c = b(f);
      this.addAriaAndCollapsedClass(g(c), c)
    }, this)).end()
  };
  f.prototype.addAriaAndCollapsedClass = function(b, c) {
    var e = b.hasClass("in");
    b.attr("aria-expanded", e);
    c.toggleClass("collapsed", !e).attr("aria-expanded", e)
  };
  var c = b.fn.collapse;
  b.fn.collapse = h;
  b.fn.collapse.Constructor = f;
  b.fn.collapse.noConflict = function() {
    return b.fn.collapse = c, this
  };
  b(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(c) {
    var d = b(this);
    d.attr("data-target") ||
      c.preventDefault();
    c = g(d);
    d = c.data("bs.collapse") ? "toggle" : d.data();
    h.call(c, d)
  })
}(jQuery); +

/* ============================================================
   SWIPER
   STATUS: KEEP
   PURPOSE:
   Provides touch-enabled sliders and carousels.
   USED BY BEDZ KING:
   Yes
   ACTION:
   Review for future optimization after Bootstrap cleanup.
   ============================================================ */

! function() {
  function b(b) {
    b.fn.swiper = function(c) {
      var e;
      return b(this).each(function() {
        var b = new h(this, c);
        e || (e = b)
      }), e
    }
  }
  var g, h = function(b, c) {
    function e() {
      return "horizontal" === a.params.direction
    }

    function d() {
      a.autoplayTimeoutId = setTimeout(function() {
        a.params.loop ? (a.fixLoop(), a._slideNext()) : a.isEnd ? c.autoplayStopOnLast ? a.stopAutoplay() : a._slideTo(0) : a._slideNext()
      }, a.params.autoplay)
    }

    function f(a, b) {
      a = g(a.target);
      if (!a.is(b))
        if ("string" == typeof b) a = a.parents(b);
        else if (b.nodeType) {
        var k;
        return a.parents().each(function(a,
          c) {
          c === b && (k = b)
        }), k ? b : void 0
      }
      return 0 === a.length ? void 0 : a[0]
    }

    function l(b, c) {
      c = c || {};
      var k = new(window.MutationObserver || window.WebkitMutationObserver)(function(b) {
        b.forEach(function(b) {
          a.onResize(!0);
          a.emit("onObserverUpdate", a, b)
        })
      });
      k.observe(b, {
        attributes: "undefined" == typeof c.attributes ? !0 : c.attributes,
        childList: "undefined" == typeof c.childList ? !0 : c.childList,
        characterData: "undefined" == typeof c.characterData ? !0 : c.characterData
      });
      a.observers.push(k)
    }

    function C(b) {
      b.originalEvent && (b = b.originalEvent);
      var k = b.keyCode || b.charCode;
      if (!a.params.allowSwipeToNext && (e() && 39 === k || !e() && 40 === k) || !a.params.allowSwipeToPrev && (e() && 37 === k || !e() && 38 === k)) return !1;
      if (!(b.shiftKey || b.altKey || b.ctrlKey || b.metaKey || document.activeElement && document.activeElement.nodeName && ("input" === document.activeElement.nodeName.toLowerCase() || "textarea" === document.activeElement.nodeName.toLowerCase()))) {
        if (37 === k || 39 === k || 38 === k || 40 === k) {
          var c = !1;
          if (0 < a.container.parents(".swiper-slide").length && 0 === a.container.parents(".swiper-slide-active").length) return;
          var d = window.pageXOffset,
            f = window.pageYOffset,
            h = window.innerWidth,
            g = window.innerHeight,
            l = a.container.offset();
          a.rtl && (l.left -= a.container[0].scrollLeft);
          l = [
            [l.left, l.top],
            [l.left + a.width, l.top],
            [l.left, l.top + a.height],
            [l.left + a.width, l.top + a.height]
          ];
          for (var A = 0; A < l.length; A++) {
            var n = l[A];
            n[0] >= d && n[0] <= d + h && n[1] >= f && n[1] <= f + g && (c = !0)
          }
          if (!c) return
        }
        e() ? ((37 === k || 39 === k) && (b.preventDefault ? b.preventDefault() : b.returnValue = !1), (39 === k && !a.rtl || 37 === k && a.rtl) && a.slideNext(), (37 === k && !a.rtl || 39 === k && a.rtl) &&
          a.slidePrev()) : ((38 === k || 40 === k) && (b.preventDefault ? b.preventDefault() : b.returnValue = !1), 40 === k && a.slideNext(), 38 === k && a.slidePrev())
      }
    }

    function y(b) {
      b.originalEvent && (b = b.originalEvent);
      var k = a.mousewheel.event,
        c = 0;
      if (b.detail) c = -b.detail;
      else if ("mousewheel" === k)
        if (a.params.mousewheelForceToAxis)
          if (e()) {
            if (!(Math.abs(b.wheelDeltaX) > Math.abs(b.wheelDeltaY))) return;
            c = b.wheelDeltaX
          } else {
            if (!(Math.abs(b.wheelDeltaY) > Math.abs(b.wheelDeltaX))) return;
            c = b.wheelDeltaY
          }
      else c = b.wheelDelta;
      else if ("DOMMouseScroll" ===
        k) c = -b.detail;
      else if ("wheel" === k)
        if (a.params.mousewheelForceToAxis)
          if (e()) {
            if (!(Math.abs(b.deltaX) > Math.abs(b.deltaY))) return;
            c = -b.deltaX
          } else {
            if (!(Math.abs(b.deltaY) > Math.abs(b.deltaX))) return;
            c = -b.deltaY
          }
      else c = Math.abs(b.deltaX) > Math.abs(b.deltaY) ? -b.deltaX : -b.deltaY;
      if (a.params.mousewheelInvert && (c = -c), a.params.freeMode) {
        if (k = a.getWrapperTranslate() + c, 0 < k && (k = 0), k < a.maxTranslate() && (k = a.maxTranslate()), a.setWrapperTransition(0), a.setWrapperTranslate(k), a.updateProgress(), a.updateActiveIndex(),
          a.params.freeModeSticky && (clearTimeout(a.mousewheel.timeout), a.mousewheel.timeout = setTimeout(function() {
            a.slideReset()
          }, 300)), 0 === k || k === a.maxTranslate()) return
      } else {
        if (60 < (new window.Date).getTime() - a.mousewheel.lastScrollTime)
          if (0 > c)
            if (a.isEnd) {
              if (a.params.mousewheelReleaseOnEdges) return !0
            } else a.slideNext();
        else if (a.isBeginning) {
          if (a.params.mousewheelReleaseOnEdges) return !0
        } else a.slidePrev();
        a.mousewheel.lastScrollTime = (new window.Date).getTime()
      }
      return a.params.autoplay && a.stopAutoplay(), b.preventDefault ?
        b.preventDefault() : b.returnValue = !1, !1
    }

    function B(a, b) {
      a = g(a);
      var k = a.attr("data-swiper-parallax") || "0";
      var c = a.attr("data-swiper-parallax-x");
      var d = a.attr("data-swiper-parallax-y");
      c || d ? (c = c || "0", d = d || "0") : e() ? (c = k, d = "0") : (d = k, c = "0");
      c = 0 <= c.indexOf("%") ? parseInt(c, 10) * b + "%" : c * b + "px";
      d = 0 <= d.indexOf("%") ? parseInt(d, 10) * b + "%" : d * b + "px";
      a.transform("translate3d(" + c + ", " + d + ",0px)")
    }

    function M(a) {
      return 0 !== a.indexOf("on") && (a = a[0] !== a[0].toUpperCase() ? "on" + a[0].toUpperCase() + a.substring(1) : "on" + a), a
    }
    if (!(this instanceof h)) return new h(b, c);
    var F = {
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        autoplay: !1,
        autoplayDisableOnInteraction: !0,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeSticky: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        coverflow: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: !0
        },
        cube: {
          slideShadows: !0,
          shadow: !0,
          shadowOffset: 20,
          shadowScale: .94
        },
        fade: {
          crossFade: !1
        },
        parallax: !1,
        scrollbar: null,
        scrollbarHide: !0,
        keyboardControl: !1,
        mousewheelControl: !1,
        mousewheelReleaseOnEdges: !1,
        mousewheelInvert: !1,
        mousewheelForceToAxis: !1,
        hashnav: !1,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        centeredSlides: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        onlyExternal: !1,
        threshold: 0,
        touchMoveStopPropagation: !0,
        pagination: null,
        paginationElement: "span",
        paginationClickable: !1,
        paginationHide: !1,
        paginationBulletRender: null,
        resistance: !0,
        resistanceRatio: .85,
        nextButton: null,
        prevButton: null,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        lazyLoading: !1,
        lazyLoadingInPrevNext: !1,
        lazyLoadingOnTransitionStart: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        control: void 0,
        controlInverse: !1,
        controlBy: "slide",
        allowSwipeToPrev: !0,
        allowSwipeToNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        slideClass: "swiper-slide",
        slideActiveClass: "swiper-slide-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slidePrevClass: "swiper-slide-prev",
        wrapperClass: "swiper-wrapper",
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active",
        buttonDisabledClass: "swiper-button-disabled",
        paginationHiddenClass: "swiper-pagination-hidden",
        observer: !1,
        observeParents: !1,
        a11y: !1,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
        runCallbacksOnInit: !0
      },
      Q = c && c.virtualTranslate;
    c = c || {};
    for (var w in F)
      if ("undefined" == typeof c[w]) c[w] = F[w];
      else if ("object" == typeof c[w])
      for (var N in F[w]) "undefined" == typeof c[w][N] && (c[w][N] = F[w][N]);
    var a = this;
    if (a.version = "3.1.0", a.params = c, a.classNames = [], "undefined" !=
      typeof g && "undefined" != typeof Dom7 && (g = Dom7), ("undefined" != typeof g || (g = "undefined" == typeof Dom7 ? window.Dom7 || window.Zepto || window.jQuery : Dom7)) && (a.$ = g, a.container = g(b), 0 !== a.container.length)) {
      if (1 < a.container.length) return void a.container.each(function() {
        new h(this, c)
      });
      a.container[0].swiper = a;
      a.container.data("swiper", a);
      a.classNames.push("swiper-container-" + a.params.direction);
      a.params.freeMode && a.classNames.push("swiper-container-free-mode");
      a.support.flexbox || (a.classNames.push("swiper-container-no-flexbox"),
        a.params.slidesPerColumn = 1);
      (a.params.parallax || a.params.watchSlidesVisibility) && (a.params.watchSlidesProgress = !0);
      0 <= ["cube", "coverflow"].indexOf(a.params.effect) && (a.support.transforms3d ? (a.params.watchSlidesProgress = !0, a.classNames.push("swiper-container-3d")) : a.params.effect = "slide");
      "slide" !== a.params.effect && a.classNames.push("swiper-container-" + a.params.effect);
      "cube" === a.params.effect && (a.params.resistanceRatio = 0, a.params.slidesPerView = 1, a.params.slidesPerColumn = 1, a.params.slidesPerGroup =
        1, a.params.centeredSlides = !1, a.params.spaceBetween = 0, a.params.virtualTranslate = !0, a.params.setWrapperSize = !1);
      "fade" === a.params.effect && (a.params.slidesPerView = 1, a.params.slidesPerColumn = 1, a.params.slidesPerGroup = 1, a.params.watchSlidesProgress = !0, a.params.spaceBetween = 0, "undefined" == typeof Q && (a.params.virtualTranslate = !0));
      a.params.grabCursor && a.support.touch && (a.params.grabCursor = !1);
      a.wrapper = a.container.children("." + a.params.wrapperClass);
      a.params.pagination && (a.paginationContainer = g(a.params.pagination),
        a.params.paginationClickable && a.paginationContainer.addClass("swiper-pagination-clickable"));
      a.rtl = e() && ("rtl" === a.container[0].dir.toLowerCase() || "rtl" === a.container.css("direction"));
      a.rtl && a.classNames.push("swiper-container-rtl");
      a.rtl && (a.wrongRTL = "-webkit-box" === a.wrapper.css("display"));
      1 < a.params.slidesPerColumn && a.classNames.push("swiper-container-multirow");
      a.device.android && a.classNames.push("swiper-container-android");
      a.container.addClass(a.classNames.join(" "));
      a.translate = 0;
      a.progress =
        0;
      a.velocity = 0;
      a.lockSwipeToNext = function() {
        a.params.allowSwipeToNext = !1
      };
      a.lockSwipeToPrev = function() {
        a.params.allowSwipeToPrev = !1
      };
      a.lockSwipes = function() {
        a.params.allowSwipeToNext = a.params.allowSwipeToPrev = !1
      };
      a.unlockSwipeToNext = function() {
        a.params.allowSwipeToNext = !0
      };
      a.unlockSwipeToPrev = function() {
        a.params.allowSwipeToPrev = !0
      };
      a.unlockSwipes = function() {
        a.params.allowSwipeToNext = a.params.allowSwipeToPrev = !0
      };
      a.params.grabCursor && (a.container[0].style.cursor = "move", a.container[0].style.cursor =
        "-webkit-grab", a.container[0].style.cursor = "-moz-grab", a.container[0].style.cursor = "grab");
      a.imagesToLoad = [];
      a.imagesLoaded = 0;
      a.loadImage = function(a, b, c, e) {
        function k() {
          e && e()
        }
        var d;
        a.complete && c ? k() : b ? (d = new window.Image, d.onload = k, d.onerror = k, d.src = b) : k()
      };
      a.preloadImages = function() {
        function b() {
          "undefined" != typeof a && null !== a && (void 0 !== a.imagesLoaded && a.imagesLoaded++, a.imagesLoaded === a.imagesToLoad.length && (a.params.updateOnImagesReady && a.update(), a.emit("onImagesReady", a)))
        }
        a.imagesToLoad = a.container.find("img");
        for (var c = 0; c < a.imagesToLoad.length; c++) a.loadImage(a.imagesToLoad[c], a.imagesToLoad[c].currentSrc || a.imagesToLoad[c].getAttribute("src"), !0, b)
      };
      a.autoplayTimeoutId = void 0;
      a.autoplaying = !1;
      a.autoplayPaused = !1;
      a.startAutoplay = function() {
        return "undefined" != typeof a.autoplayTimeoutId ? !1 : a.params.autoplay ? a.autoplaying ? !1 : (a.autoplaying = !0, a.emit("onAutoplayStart", a), void d()) : !1
      };
      a.stopAutoplay = function(b) {
        a.autoplayTimeoutId && (a.autoplayTimeoutId && clearTimeout(a.autoplayTimeoutId), a.autoplaying = !1,
          a.autoplayTimeoutId = void 0, a.emit("onAutoplayStop", a))
      };
      a.pauseAutoplay = function(b) {
        a.autoplayPaused || (a.autoplayTimeoutId && clearTimeout(a.autoplayTimeoutId), a.autoplayPaused = !0, 0 === b ? (a.autoplayPaused = !1, d()) : a.wrapper.transitionEnd(function() {
          a && (a.autoplayPaused = !1, a.autoplaying ? d() : a.stopAutoplay())
        }))
      };
      a.minTranslate = function() {
        return -a.snapGrid[0]
      };
      a.maxTranslate = function() {
        return -a.snapGrid[a.snapGrid.length - 1]
      };
      a.updateContainerSize = function() {
        var b = "undefined" != typeof a.params.width ? a.params.width :
          a.container[0].clientWidth;
        var c = "undefined" != typeof a.params.height ? a.params.height : a.container[0].clientHeight;
        0 === b && e() || 0 === c && !e() || (b = b - parseInt(a.container.css("padding-left"), 10) - parseInt(a.container.css("padding-right"), 10), c = c - parseInt(a.container.css("padding-top"), 10) - parseInt(a.container.css("padding-bottom"), 10), a.width = b, a.height = c, a.size = e() ? a.width : a.height)
      };
      a.updateSlidesSize = function() {
        a.slides = a.wrapper.children("." + a.params.slideClass);
        a.snapGrid = [];
        a.slidesGrid = [];
        a.slidesSizesGrid = [];
        var b, c = a.params.spaceBetween,
          d = -a.params.slidesOffsetBefore,
          f = 0,
          h = 0;
        "string" == typeof c && 0 <= c.indexOf("%") && (c = parseFloat(c.replace("%", "")) / 100 * a.size);
        a.virtualSize = -c;
        a.slides.css(a.rtl ? {
          marginLeft: "",
          marginTop: ""
        } : {
          marginRight: "",
          marginBottom: ""
        });
        var g;
        1 < a.params.slidesPerColumn && (g = Math.floor(a.slides.length / a.params.slidesPerColumn) === a.slides.length / a.params.slidesPerColumn ? a.slides.length : Math.ceil(a.slides.length / a.params.slidesPerColumn) * a.params.slidesPerColumn);
        var l = a.params.slidesPerColumn,
          t = g / l,
          A = t - (a.params.slidesPerColumn * t - a.slides.length);
        for (b = 0; b < a.slides.length; b++) {
          var n = 0;
          var m = a.slides.eq(b);
          if (1 < a.params.slidesPerColumn) {
            var q, p, u;
            "column" === a.params.slidesPerColumnFill ? (p = Math.floor(b / l), u = b - p * l, (p > A || p === A && u === l - 1) && ++u >= l && (u = 0, p++), q = p + u * g / l, m.css({
              "-webkit-box-ordinal-group": q,
              "-moz-box-ordinal-group": q,
              "-ms-flex-order": q,
              "-webkit-order": q,
              order: q
            })) : (u = Math.floor(b / t), p = b - u * t);
            m.css({
              "margin-top": 0 !== u && a.params.spaceBetween && a.params.spaceBetween + "px"
            }).attr("data-swiper-column",
              p).attr("data-swiper-row", u)
          }
          "none" !== m.css("display") && ("auto" === a.params.slidesPerView ? (n = e() ? m.outerWidth(!0) : m.outerHeight(!0), a.params.roundLengths && (n = Math.floor(n))) : (n = (a.size - (a.params.slidesPerView - 1) * c) / a.params.slidesPerView, a.params.roundLengths && (n = Math.floor(n)), e() ? a.slides[b].style.width = n + "px" : a.slides[b].style.height = n + "px"), a.slides[b].swiperSlideSize = n, a.slidesSizesGrid.push(n), a.params.centeredSlides ? (d = d + n / 2 + f / 2 + c, 0 === b && (d = d - a.size / 2 - c), .001 > Math.abs(d) && (d = 0), 0 === h % a.params.slidesPerGroup &&
            a.snapGrid.push(d), a.slidesGrid.push(d)) : (0 === h % a.params.slidesPerGroup && a.snapGrid.push(d), a.slidesGrid.push(d), d = d + n + c), a.virtualSize += n + c, f = n, h++)
        }
        a.virtualSize = Math.max(a.virtualSize, a.size) + a.params.slidesOffsetAfter;
        if (a.rtl && a.wrongRTL && ("slide" === a.params.effect || "coverflow" === a.params.effect) && a.wrapper.css({
            width: a.virtualSize + a.params.spaceBetween + "px"
          }), (!a.support.flexbox || a.params.setWrapperSize) && a.wrapper.css(e() ? {
            width: a.virtualSize + a.params.spaceBetween + "px"
          } : {
            height: a.virtualSize +
              a.params.spaceBetween + "px"
          }), 1 < a.params.slidesPerColumn && (a.virtualSize = (n + a.params.spaceBetween) * g, a.virtualSize = Math.ceil(a.virtualSize / a.params.slidesPerColumn) - a.params.spaceBetween, a.wrapper.css({
            width: a.virtualSize + a.params.spaceBetween + "px"
          }), a.params.centeredSlides)) {
          d = [];
          for (b = 0; b < a.snapGrid.length; b++) a.snapGrid[b] < a.virtualSize + a.snapGrid[0] && d.push(a.snapGrid[b]);
          a.snapGrid = d
        }
        if (!a.params.centeredSlides) {
          d = [];
          for (b = 0; b < a.snapGrid.length; b++) a.snapGrid[b] <= a.virtualSize - a.size && d.push(a.snapGrid[b]);
          a.snapGrid = d;
          Math.floor(a.virtualSize - a.size) > Math.floor(a.snapGrid[a.snapGrid.length - 1]) && a.snapGrid.push(a.virtualSize - a.size)
        }
        0 === a.snapGrid.length && (a.snapGrid = [0]);
        0 !== a.params.spaceBetween && a.slides.css(e() ? a.rtl ? {
          marginLeft: c + "px"
        } : {
          marginRight: c + "px"
        } : {
          marginBottom: c + "px"
        });
        a.params.watchSlidesProgress && a.updateSlidesOffset()
      };
      a.updateSlidesOffset = function() {
        for (var b = 0; b < a.slides.length; b++) a.slides[b].swiperSlideOffset = e() ? a.slides[b].offsetLeft : a.slides[b].offsetTop
      };
      a.updateSlidesProgress =
        function(b) {
          if ("undefined" == typeof b && (b = a.translate || 0), 0 !== a.slides.length) {
            "undefined" == typeof a.slides[0].swiperSlideOffset && a.updateSlidesOffset();
            var c = a.params.centeredSlides ? -b + a.size / 2 : -b;
            a.rtl && (c = a.params.centeredSlides ? b - a.size / 2 : b);
            a.container[0].getBoundingClientRect();
            e() ? "left" : "top";
            e() ? "right" : "bottom";
            a.slides.removeClass(a.params.slideVisibleClass);
            for (b = 0; b < a.slides.length; b++) {
              var k = a.slides[b],
                d = !0 === a.params.centeredSlides ? k.swiperSlideSize / 2 : 0,
                f = (c - k.swiperSlideOffset - d) /
                (k.swiperSlideSize + a.params.spaceBetween);
              if (a.params.watchSlidesVisibility) {
                d = -(c - k.swiperSlideOffset - d);
                var h = d + a.slidesSizesGrid[b];
                (0 <= d && d < a.size || 0 < h && h <= a.size || 0 >= d && h >= a.size) && a.slides.eq(b).addClass(a.params.slideVisibleClass)
              }
              k.progress = a.rtl ? -f : f
            }
          }
        };
      a.updateProgress = function(b) {
        "undefined" == typeof b && (b = a.translate || 0);
        var c = a.maxTranslate() - a.minTranslate();
        0 === c ? (a.progress = 0, a.isBeginning = a.isEnd = !0) : (a.progress = (b - a.minTranslate()) / c, a.isBeginning = 0 >= a.progress, a.isEnd = 1 <= a.progress);
        a.isBeginning && a.emit("onReachBeginning", a);
        a.isEnd && a.emit("onReachEnd", a);
        a.params.watchSlidesProgress && a.updateSlidesProgress(b);
        a.emit("onProgress", a, a.progress)
      };
      a.updateActiveIndex = function() {
        var b, c, e = a.rtl ? a.translate : -a.translate;
        for (c = 0; c < a.slidesGrid.length; c++) "undefined" != typeof a.slidesGrid[c + 1] ? e >= a.slidesGrid[c] && e < a.slidesGrid[c + 1] - (a.slidesGrid[c + 1] - a.slidesGrid[c]) / 2 ? b = c : e >= a.slidesGrid[c] && e < a.slidesGrid[c + 1] && (b = c + 1) : e >= a.slidesGrid[c] && (b = c);
        (0 > b || "undefined" == typeof b) && (b =
          0);
        c = Math.floor(b / a.params.slidesPerGroup);
        c >= a.snapGrid.length && (c = a.snapGrid.length - 1);
        b !== a.activeIndex && (a.snapIndex = c, a.previousIndex = a.activeIndex, a.activeIndex = b, a.updateClasses())
      };
      a.updateClasses = function() {
        a.slides.removeClass(a.params.slideActiveClass + " " + a.params.slideNextClass + " " + a.params.slidePrevClass);
        var b = a.slides.eq(a.activeIndex);
        if (b.addClass(a.params.slideActiveClass), b.next("." + a.params.slideClass).addClass(a.params.slideNextClass), b.prev("." + a.params.slideClass).addClass(a.params.slidePrevClass),
          a.bullets && 0 < a.bullets.length) {
          a.bullets.removeClass(a.params.bulletActiveClass);
          var c;
          a.params.loop ? (c = Math.ceil(a.activeIndex - a.loopedSlides) / a.params.slidesPerGroup, c > a.slides.length - 1 - 2 * a.loopedSlides && (c -= a.slides.length - 2 * a.loopedSlides), c > a.bullets.length - 1 && (c -= a.bullets.length)) : c = "undefined" != typeof a.snapIndex ? a.snapIndex : a.activeIndex || 0;
          1 < a.paginationContainer.length ? a.bullets.each(function() {
            g(this).index() === c && g(this).addClass(a.params.bulletActiveClass)
          }) : a.bullets.eq(c).addClass(a.params.bulletActiveClass)
        }
        a.params.loop ||
          (a.params.prevButton && (a.isBeginning ? (g(a.params.prevButton).addClass(a.params.buttonDisabledClass), a.params.a11y && a.a11y && a.a11y.disable(g(a.params.prevButton))) : (g(a.params.prevButton).removeClass(a.params.buttonDisabledClass), a.params.a11y && a.a11y && a.a11y.enable(g(a.params.prevButton)))), a.params.nextButton && (a.isEnd ? (g(a.params.nextButton).addClass(a.params.buttonDisabledClass), a.params.a11y && a.a11y && a.a11y.disable(g(a.params.nextButton))) : (g(a.params.nextButton).removeClass(a.params.buttonDisabledClass),
            a.params.a11y && a.a11y && a.a11y.enable(g(a.params.nextButton)))))
      };
      a.updatePagination = function() {
        if (a.params.pagination && a.paginationContainer && 0 < a.paginationContainer.length) {
          for (var b = "", c = a.params.loop ? Math.ceil((a.slides.length - 2 * a.loopedSlides) / a.params.slidesPerGroup) : a.snapGrid.length, e = 0; c > e; e++) b += a.params.paginationBulletRender ? a.params.paginationBulletRender(e, a.params.bulletClass) : "<" + a.params.paginationElement + ' class="' + a.params.bulletClass + '"></' + a.params.paginationElement + ">";
          a.paginationContainer.html(b);
          a.bullets = a.paginationContainer.find("." + a.params.bulletClass);
          a.params.paginationClickable && a.params.a11y && a.a11y && a.a11y.initPagination()
        }
      };
      a.update = function(b) {
        function c() {
          e = Math.min(Math.max(a.translate, a.maxTranslate()), a.minTranslate());
          a.setWrapperTranslate(e);
          a.updateActiveIndex();
          a.updateClasses()
        }
        if (a.updateContainerSize(), a.updateSlidesSize(), a.updateProgress(), a.updatePagination(), a.updateClasses(), a.params.scrollbar && a.scrollbar && a.scrollbar.set(), b) {
          var k, e;
          a.controller && a.controller.spline &&
            (a.controller.spline = void 0);
          a.params.freeMode ? c() : (k = ("auto" === a.params.slidesPerView || 1 < a.params.slidesPerView) && a.isEnd && !a.params.centeredSlides ? a.slideTo(a.slides.length - 1, 0, !1, !0) : a.slideTo(a.activeIndex, 0, !1, !0), k || c())
        }
      };
      a.onResize = function(b) {
        var c = a.params.allowSwipeToPrev,
          k = a.params.allowSwipeToNext;
        (a.params.allowSwipeToPrev = a.params.allowSwipeToNext = !0, a.updateContainerSize(), a.updateSlidesSize(), ("auto" === a.params.slidesPerView || a.params.freeMode || b) && a.updatePagination(), a.params.scrollbar &&
          a.scrollbar && a.scrollbar.set(), a.controller && a.controller.spline && (a.controller.spline = void 0), a.params.freeMode) ? (b = Math.min(Math.max(a.translate, a.maxTranslate()), a.minTranslate()), a.setWrapperTranslate(b), a.updateActiveIndex(), a.updateClasses()) : (a.updateClasses(), ("auto" === a.params.slidesPerView || 1 < a.params.slidesPerView) && a.isEnd && !a.params.centeredSlides ? a.slideTo(a.slides.length - 1, 0, !1, !0) : a.slideTo(a.activeIndex, 0, !1, !0));
        a.params.allowSwipeToPrev = c;
        a.params.allowSwipeToNext = k
      };
      b = ["mousedown",
        "mousemove", "mouseup"
      ];
      window.navigator.pointerEnabled ? b = ["pointerdown", "pointermove", "pointerup"] : window.navigator.msPointerEnabled && (b = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]);
      a.touchEvents = {
        start: a.support.touch || !a.params.simulateTouch ? "touchstart" : b[0],
        move: a.support.touch || !a.params.simulateTouch ? "touchmove" : b[1],
        end: a.support.touch || !a.params.simulateTouch ? "touchend" : b[2]
      };
      (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && ("container" === a.params.touchEventsTarget ?
        a.container : a.wrapper).addClass("swiper-wp8-" + a.params.direction);
      a.initEvents = function(b) {
        var k = b ? "off" : "on";
        b = b ? "removeEventListener" : "addEventListener";
        var e = "container" === a.params.touchEventsTarget ? a.container[0] : a.wrapper[0],
          d = a.support.touch ? e : document,
          f = a.params.nested ? !0 : !1;
        a.browser.ie ? (e[b](a.touchEvents.start, a.onTouchStart, !1), d[b](a.touchEvents.move, a.onTouchMove, f), d[b](a.touchEvents.end, a.onTouchEnd, !1)) : (a.support.touch && (e[b](a.touchEvents.start, a.onTouchStart, !1), e[b](a.touchEvents.move,
          a.onTouchMove, f), e[b](a.touchEvents.end, a.onTouchEnd, !1)), !c.simulateTouch || a.device.ios || a.device.android || (e[b]("mousedown", a.onTouchStart, !1), document[b]("mousemove", a.onTouchMove, f), document[b]("mouseup", a.onTouchEnd, !1)));
        window[b]("resize", a.onResize);
        a.params.nextButton && (g(a.params.nextButton)[k]("click", a.onClickNext), a.params.a11y && a.a11y && g(a.params.nextButton)[k]("keydown", a.a11y.onEnterKey));
        a.params.prevButton && (g(a.params.prevButton)[k]("click", a.onClickPrev), a.params.a11y && a.a11y &&
          g(a.params.prevButton)[k]("keydown", a.a11y.onEnterKey));
        a.params.pagination && a.params.paginationClickable && (g(a.paginationContainer)[k]("click", "." + a.params.bulletClass, a.onClickIndex), a.params.a11y && a.a11y && g(a.paginationContainer)[k]("keydown", "." + a.params.bulletClass, a.a11y.onEnterKey));
        (a.params.preventClicks || a.params.preventClicksPropagation) && e[b]("click", a.preventClicks, !0)
      };
      a.attachEvents = function(b) {
        a.initEvents()
      };
      a.detachEvents = function() {
        a.initEvents(!0)
      };
      a.allowClick = !0;
      a.preventClicks =
        function(b) {
          a.allowClick || (a.params.preventClicks && b.preventDefault(), a.params.preventClicksPropagation && a.animating && (b.stopPropagation(), b.stopImmediatePropagation()))
        };
      a.onClickNext = function(b) {
        b.preventDefault();
        a.isEnd && !a.params.loop || a.slideNext()
      };
      a.onClickPrev = function(b) {
        b.preventDefault();
        a.isBeginning && !a.params.loop || a.slidePrev()
      };
      a.onClickIndex = function(b) {
        b.preventDefault();
        b = g(this).index() * a.params.slidesPerGroup;
        a.params.loop && (b += a.loopedSlides);
        a.slideTo(b)
      };
      a.updateClickedSlide =
        function(b) {
          b = f(b, "." + a.params.slideClass);
          var c = !1;
          if (b)
            for (var e = 0; e < a.slides.length; e++) a.slides[e] === b && (c = !0);
          if (!b || !c) return a.clickedSlide = void 0, void(a.clickedIndex = void 0);
          if (a.clickedSlide = b, a.clickedIndex = g(b).index(), a.params.slideToClickedSlide && void 0 !== a.clickedIndex && a.clickedIndex !== a.activeIndex) {
            var k = a.clickedIndex;
            a.params.loop ? (b = g(a.clickedSlide).attr("data-swiper-slide-index"), k > a.slides.length - a.params.slidesPerView) ? (a.fixLoop(), k = a.wrapper.children("." + a.params.slideClass +
              '[data-swiper-slide-index="' + b + '"]').eq(0).index(), setTimeout(function() {
              a.slideTo(k)
            }, 0)) : k < a.params.slidesPerView - 1 ? (a.fixLoop(), b = a.wrapper.children("." + a.params.slideClass + '[data-swiper-slide-index="' + b + '"]'), k = b.eq(b.length - 1).index(), setTimeout(function() {
              a.slideTo(k)
            }, 0)) : a.slideTo(k) : a.slideTo(k)
          }
        };
      var v, x, G, D, p, u, H, E, I, O = Date.now(),
        z = [];
      a.animating = !1;
      a.touches = {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      };
      var J, K;
      if (a.onTouchStart = function(b) {
          if (b.originalEvent && (b = b.originalEvent), J =
            "touchstart" === b.type, J || !("which" in b) || 3 !== b.which) {
            if (a.params.noSwiping && f(b, "." + a.params.noSwipingClass)) return void(a.allowClick = !0);
            if (!a.params.swipeHandler || f(b, a.params.swipeHandler)) {
              if (v = !0, x = !1, D = void 0, K = void 0, a.touches.startX = a.touches.currentX = "touchstart" === b.type ? b.targetTouches[0].pageX : b.pageX, a.touches.startY = a.touches.currentY = "touchstart" === b.type ? b.targetTouches[0].pageY : b.pageY, G = Date.now(), a.allowClick = !0, a.updateContainerSize(), a.swipeDirection = void 0, 0 < a.params.threshold &&
                (H = !1), "touchstart" !== b.type) {
                var c = !0;
                g(b.target).is("input, select, textarea, button") && (c = !1);
                document.activeElement && g(document.activeElement).is("input, select, textarea, button") && document.activeElement.blur();
                c && b.preventDefault()
              }
              a.emit("onTouchStart", a, b)
            }
          }
        }, a.onTouchMove = function(b) {
          if (b.originalEvent && (b = b.originalEvent), !(J && "mousemove" === b.type || b.preventedByNestedSwiper)) {
            if (a.params.onlyExternal) return a.allowClick = !1, void(v && (a.touches.startX = a.touches.currentX = "touchmove" === b.type ?
              b.targetTouches[0].pageX : b.pageX, a.touches.startY = a.touches.currentY = "touchmove" === b.type ? b.targetTouches[0].pageY : b.pageY, G = Date.now()));
            if (J && document.activeElement && b.target === document.activeElement && g(b.target).is("input, select, textarea, button")) return x = !0, void(a.allowClick = !1);
            if (a.emit("onTouchMove", a, b), !(b.targetTouches && 1 < b.targetTouches.length)) {
              if (a.touches.currentX = "touchmove" === b.type ? b.targetTouches[0].pageX : b.pageX, a.touches.currentY = "touchmove" === b.type ? b.targetTouches[0].pageY :
                b.pageY, "undefined" == typeof D) {
                var d = 180 * Math.atan2(Math.abs(a.touches.currentY - a.touches.startY), Math.abs(a.touches.currentX - a.touches.startX)) / Math.PI;
                D = e() ? d > a.params.touchAngle : 90 - d > a.params.touchAngle
              }
              if (D && a.emit("onTouchMoveOpposite", a, b), "undefined" == typeof K && a.browser.ieTouch && (a.touches.currentX !== a.touches.startX || a.touches.currentY !== a.touches.startY) && (K = !0), v) {
                if (D) return void(v = !1);
                if (K || !a.browser.ieTouch) {
                  a.allowClick = !1;
                  a.emit("onSliderMove", a, b);
                  b.preventDefault();
                  a.params.touchMoveStopPropagation &&
                    !a.params.nested && b.stopPropagation();
                  x || (c.loop && a.fixLoop(), u = a.getWrapperTranslate(), a.setWrapperTransition(0), a.animating && a.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"), a.params.autoplay && a.autoplaying && (a.params.autoplayDisableOnInteraction ? a.stopAutoplay() : a.pauseAutoplay()), I = !1, a.params.grabCursor && (a.container[0].style.cursor = "move", a.container[0].style.cursor = "-webkit-grabbing", a.container[0].style.cursor = "-moz-grabbin", a.container[0].style.cursor =
                    "grabbing"));
                  x = !0;
                  d = a.touches.diff = e() ? a.touches.currentX - a.touches.startX : a.touches.currentY - a.touches.startY;
                  d *= a.params.touchRatio;
                  a.rtl && (d = -d);
                  a.swipeDirection = 0 < d ? "prev" : "next";
                  p = d + u;
                  var k = !0;
                  if (0 < d && p > a.minTranslate() ? (k = !1, a.params.resistance && (p = a.minTranslate() - 1 + Math.pow(-a.minTranslate() + u + d, a.params.resistanceRatio))) : 0 > d && p < a.maxTranslate() && (k = !1, a.params.resistance && (p = a.maxTranslate() + 1 - Math.pow(a.maxTranslate() - u - d, a.params.resistanceRatio))), k && (b.preventedByNestedSwiper = !0), !a.params.allowSwipeToNext &&
                    "next" === a.swipeDirection && u > p && (p = u), !a.params.allowSwipeToPrev && "prev" === a.swipeDirection && p > u && (p = u), a.params.followFinger) {
                    if (0 < a.params.threshold) {
                      if (!(Math.abs(d) > a.params.threshold || H)) return void(p = u);
                      if (!H) return H = !0, a.touches.startX = a.touches.currentX, a.touches.startY = a.touches.currentY, p = u, void(a.touches.diff = e() ? a.touches.currentX - a.touches.startX : a.touches.currentY - a.touches.startY)
                    }(a.params.freeMode || a.params.watchSlidesProgress) && a.updateActiveIndex();
                    a.params.freeMode && (0 === z.length &&
                      z.push({
                        position: a.touches[e() ? "startX" : "startY"],
                        time: G
                      }), z.push({
                        position: a.touches[e() ? "currentX" : "currentY"],
                        time: (new window.Date).getTime()
                      }));
                    a.updateProgress(p);
                    a.setWrapperTranslate(p)
                  }
                }
              }
            }
          }
        }, a.onTouchEnd = function(b) {
          if (b.originalEvent && (b = b.originalEvent), a.emit("onTouchEnd", a, b), v) {
            a.params.grabCursor && x && v && (a.container[0].style.cursor = "move", a.container[0].style.cursor = "-webkit-grab", a.container[0].style.cursor = "-moz-grab", a.container[0].style.cursor = "grab");
            var c = Date.now(),
              e = c - G;
            if (a.allowClick &&
              (a.updateClickedSlide(b), a.emit("onTap", a, b), 300 > e && 300 < c - O && (E && clearTimeout(E), E = setTimeout(function() {
                a && (a.params.paginationHide && 0 < a.paginationContainer.length && !g(b.target).hasClass(a.params.bulletClass) && a.paginationContainer.toggleClass(a.params.paginationHiddenClass), a.emit("onClick", a, b))
              }, 300)), 300 > e && 300 > c - O && (E && clearTimeout(E), a.emit("onDoubleTap", a, b))), O = Date.now(), setTimeout(function() {
                a && (a.allowClick = !0)
              }, 0), !v || !x || !a.swipeDirection || 0 === a.touches.diff || p === u) return void(v = x = !1);
            v = x = !1;
            if (c = a.params.followFinger ? a.rtl ? a.translate : -a.translate : -p, a.params.freeMode) {
              if (c < -a.minTranslate()) return void a.slideTo(a.activeIndex);
              if (c > -a.maxTranslate()) return void a.slideTo(a.slides.length < a.snapGrid.length ? a.snapGrid.length - 1 : a.slides.length - 1);
              if (a.params.freeModeMomentum) {
                if (1 < z.length) {
                  c = z.pop();
                  var d = z.pop(),
                    k = c.time - d.time;
                  a.velocity = (c.position - d.position) / k;
                  a.velocity /= 2;
                  .02 > Math.abs(a.velocity) && (a.velocity = 0);
                  (150 < k || 300 < (new window.Date).getTime() - c.time) && (a.velocity =
                    0)
                } else a.velocity = 0;
                z.length = 0;
                c = 1E3 * a.params.freeModeMomentumRatio;
                d = a.translate + a.velocity * c;
                a.rtl && (d = -d);
                var f;
                k = !1;
                var h = 20 * Math.abs(a.velocity) * a.params.freeModeMomentumBounceRatio;
                if (d < a.maxTranslate()) a.params.freeModeMomentumBounce ? (d + a.maxTranslate() < -h && (d = a.maxTranslate() - h), f = a.maxTranslate(), k = !0, I = !0) : d = a.maxTranslate();
                else if (d > a.minTranslate()) a.params.freeModeMomentumBounce ? (d - a.minTranslate() > h && (d = a.minTranslate() + h), f = a.minTranslate(), k = !0, I = !0) : d = a.minTranslate();
                else if (a.params.freeModeSticky) {
                  for (h =
                    h = 0; h < a.snapGrid.length; h += 1)
                    if (a.snapGrid[h] > -d) {
                      var l = h;
                      break
                    } d = Math.abs(a.snapGrid[l] - d) < Math.abs(a.snapGrid[l - 1] - d) || "next" === a.swipeDirection ? a.snapGrid[l] : a.snapGrid[l - 1];
                  a.rtl || (d = -d)
                }
                if (0 !== a.velocity) c = Math.abs(a.rtl ? (-d - a.translate) / a.velocity : (d - a.translate) / a.velocity);
                else if (a.params.freeModeSticky) return void a.slideReset();
                a.params.freeModeMomentumBounce && k ? (a.updateProgress(f), a.setWrapperTransition(c), a.setWrapperTranslate(d), a.onTransitionStart(), a.animating = !0, a.wrapper.transitionEnd(function() {
                  a &&
                    I && (a.emit("onMomentumBounce", a), a.setWrapperTransition(a.params.speed), a.setWrapperTranslate(f), a.wrapper.transitionEnd(function() {
                      a && a.onTransitionEnd()
                    }))
                })) : a.velocity ? (a.updateProgress(d), a.setWrapperTransition(c), a.setWrapperTranslate(d), a.onTransitionStart(), a.animating || (a.animating = !0, a.wrapper.transitionEnd(function() {
                  a && a.onTransitionEnd()
                }))) : a.updateProgress(d);
                a.updateActiveIndex()
              }
              return void((!a.params.freeModeMomentum || e >= a.params.longSwipesMs) && (a.updateProgress(), a.updateActiveIndex()))
            }
            l =
              0;
            k = a.slidesSizesGrid[0];
            for (d = 0; d < a.slidesGrid.length; d += a.params.slidesPerGroup) "undefined" != typeof a.slidesGrid[d + a.params.slidesPerGroup] ? c >= a.slidesGrid[d] && c < a.slidesGrid[d + a.params.slidesPerGroup] && (l = d, k = a.slidesGrid[d + a.params.slidesPerGroup] - a.slidesGrid[d]) : c >= a.slidesGrid[d] && (l = d, k = a.slidesGrid[a.slidesGrid.length - 1] - a.slidesGrid[a.slidesGrid.length - 2]);
            c = (c - a.slidesGrid[l]) / k;
            if (e > a.params.longSwipesMs) {
              if (!a.params.longSwipes) return void a.slideTo(a.activeIndex);
              "next" === a.swipeDirection &&
                a.slideTo(c >= a.params.longSwipesRatio ? l + a.params.slidesPerGroup : l);
              "prev" === a.swipeDirection && a.slideTo(c > 1 - a.params.longSwipesRatio ? l + a.params.slidesPerGroup : l)
            } else {
              if (!a.params.shortSwipes) return void a.slideTo(a.activeIndex);
              "next" === a.swipeDirection && a.slideTo(l + a.params.slidesPerGroup);
              "prev" === a.swipeDirection && a.slideTo(l)
            }
          }
        }, a._slideTo = function(b, c) {
          return a.slideTo(b, c, !0, !0)
        }, a.slideTo = function(b, c, d, f) {
          "undefined" == typeof d && (d = !0);
          "undefined" == typeof b && (b = 0);
          0 > b && (b = 0);
          a.snapIndex = Math.floor(b /
            a.params.slidesPerGroup);
          a.snapIndex >= a.snapGrid.length && (a.snapIndex = a.snapGrid.length - 1);
          var k = -a.snapGrid[a.snapIndex];
          if (!a.params.allowSwipeToNext && k < a.translate && k < a.minTranslate() || !a.params.allowSwipeToPrev && k > a.translate && k > a.maxTranslate()) return !1;
          a.params.autoplay && a.autoplaying && (f || !a.params.autoplayDisableOnInteraction ? a.pauseAutoplay(c) : a.stopAutoplay());
          a.updateProgress(k);
          for (f = 0; f < a.slidesGrid.length; f++) - Math.floor(100 * k) >= Math.floor(100 * a.slidesGrid[f]) && (b = f);
          if ("undefined" ==
            typeof c && (c = a.params.speed), a.previousIndex = a.activeIndex || 0, a.activeIndex = b, k === a.translate) return a.updateClasses(), !1;
          a.updateClasses();
          a.onTransitionStart(d);
          e() ? k : 0;
          e() ? 0 : k;
          return 0 === c ? (a.setWrapperTransition(0), a.setWrapperTranslate(k), a.onTransitionEnd(d)) : (a.setWrapperTransition(c), a.setWrapperTranslate(k), a.animating || (a.animating = !0, a.wrapper.transitionEnd(function() {
            a && a.onTransitionEnd(d)
          }))), !0
        }, a.onTransitionStart = function(b) {
          "undefined" == typeof b && (b = !0);
          a.lazy && a.lazy.onTransitionStart();
          b && (a.emit("onTransitionStart", a), a.activeIndex !== a.previousIndex && a.emit("onSlideChangeStart", a))
        }, a.onTransitionEnd = function(b) {
          a.animating = !1;
          a.setWrapperTransition(0);
          "undefined" == typeof b && (b = !0);
          a.lazy && a.lazy.onTransitionEnd();
          b && (a.emit("onTransitionEnd", a), a.activeIndex !== a.previousIndex && a.emit("onSlideChangeEnd", a));
          a.params.hashnav && a.hashnav && a.hashnav.setHash()
        }, a.slideNext = function(b, c, d) {
          if (a.params.loop) {
            if (a.animating) return !1;
            a.fixLoop();
            a.container[0].clientLeft
          }
          return a.slideTo(a.activeIndex +
            a.params.slidesPerGroup, c, b, d)
        }, a._slideNext = function(b) {
          return a.slideNext(!0, b, !0)
        }, a.slidePrev = function(b, c, d) {
          if (a.params.loop) {
            if (a.animating) return !1;
            a.fixLoop();
            a.container[0].clientLeft
          }
          return a.slideTo(a.activeIndex - 1, c, b, d)
        }, a._slidePrev = function(b) {
          return a.slidePrev(!0, b, !0)
        }, a.slideReset = function(b, c, d) {
          return a.slideTo(a.activeIndex, c, b)
        }, a.setWrapperTransition = function(b, c) {
          a.wrapper.transition(b);
          "slide" !== a.params.effect && a.effects[a.params.effect] && a.effects[a.params.effect].setTransition(b);
          a.params.parallax && a.parallax && a.parallax.setTransition(b);
          a.params.scrollbar && a.scrollbar && a.scrollbar.setTransition(b);
          a.params.control && a.controller && a.controller.setTransition(b, c);
          a.emit("onSetTransition", a, b)
        }, a.setWrapperTranslate = function(b, c, d) {
          var f = 0,
            k = 0;
          e() ? f = a.rtl ? -b : b : k = b;
          a.params.virtualTranslate || a.wrapper.transform(a.support.transforms3d ? "translate3d(" + f + "px, " + k + "px, 0px)" : "translate(" + f + "px, " + k + "px)");
          a.translate = e() ? f : k;
          c && a.updateActiveIndex();
          "slide" !== a.params.effect && a.effects[a.params.effect] &&
            a.effects[a.params.effect].setTranslate(a.translate);
          a.params.parallax && a.parallax && a.parallax.setTranslate(a.translate);
          a.params.scrollbar && a.scrollbar && a.scrollbar.setTranslate(a.translate);
          a.params.control && a.controller && a.controller.setTranslate(a.translate, d);
          a.emit("onSetTranslate", a, a.translate)
        }, a.getTranslate = function(b, c) {
          var d, e, f, k;
          return "undefined" == typeof c && (c = "x"), a.params.virtualTranslate ? a.rtl ? -a.translate : a.translate : (f = window.getComputedStyle(b, null), window.WebKitCSSMatrix ? k = new window.WebKitCSSMatrix("none" ===
            f.webkitTransform ? "" : f.webkitTransform) : (k = f.MozTransform || f.OTransform || f.MsTransform || f.msTransform || f.transform || f.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), d = k.toString().split(",")), "x" === c && (e = window.WebKitCSSMatrix ? k.m41 : parseFloat(16 === d.length ? d[12] : d[4])), "y" === c && (e = window.WebKitCSSMatrix ? k.m42 : parseFloat(16 === d.length ? d[13] : d[5])), a.rtl && e && (e = -e), e || 0)
        }, a.getWrapperTranslate = function(b) {
          return "undefined" == typeof b && (b = e() ? "x" : "y"), a.getTranslate(a.wrapper[0],
            b)
        }, a.observers = [], a.initObservers = function() {
          if (a.params.observeParents)
            for (var b = a.container.parents(), c = 0; c < b.length; c++) l(b[c]);
          l(a.container[0], {
            childList: !1
          });
          l(a.wrapper[0], {
            attributes: !1
          })
        }, a.disconnectObservers = function() {
          for (var b = 0; b < a.observers.length; b++) a.observers[b].disconnect();
          a.observers = []
        }, a.createLoop = function() {
          a.wrapper.children("." + a.params.slideClass + "." + a.params.slideDuplicateClass).remove();
          var b = a.wrapper.children("." + a.params.slideClass);
          a.loopedSlides = parseInt(a.params.loopedSlides ||
            a.params.slidesPerView, 10);
          a.loopedSlides += a.params.loopAdditionalSlides;
          a.loopedSlides > b.length && (a.loopedSlides = b.length);
          var c, d = [],
            e = [];
          b.each(function(c, f) {
            var k = g(this);
            c < a.loopedSlides && e.push(f);
            c < b.length && c >= b.length - a.loopedSlides && d.push(f);
            k.attr("data-swiper-slide-index", c)
          });
          for (c = 0; c < e.length; c++) a.wrapper.append(g(e[c].cloneNode(!0)).addClass(a.params.slideDuplicateClass));
          for (c = d.length - 1; 0 <= c; c--) a.wrapper.prepend(g(d[c].cloneNode(!0)).addClass(a.params.slideDuplicateClass))
        }, a.destroyLoop =
        function() {
          a.wrapper.children("." + a.params.slideClass + "." + a.params.slideDuplicateClass).remove();
          a.slides.removeAttr("data-swiper-slide-index")
        }, a.fixLoop = function() {
          var b;
          a.activeIndex < a.loopedSlides ? (b = a.slides.length - 3 * a.loopedSlides + a.activeIndex, b += a.loopedSlides, a.slideTo(b, 0, !1, !0)) : ("auto" === a.params.slidesPerView && a.activeIndex >= 2 * a.loopedSlides || a.activeIndex > a.slides.length - 2 * a.params.slidesPerView) && (b = -a.slides.length + a.activeIndex + a.loopedSlides, b += a.loopedSlides, a.slideTo(b, 0, !1, !0))
        },
        a.appendSlide = function(b) {
          if (a.params.loop && a.destroyLoop(), "object" == typeof b && b.length)
            for (var c = 0; c < b.length; c++) b[c] && a.wrapper.append(b[c]);
          else a.wrapper.append(b);
          a.params.loop && a.createLoop();
          a.params.observer && a.support.observer || a.update(!0)
        }, a.prependSlide = function(b) {
          a.params.loop && a.destroyLoop();
          var c = a.activeIndex + 1;
          if ("object" == typeof b && b.length) {
            for (c = 0; c < b.length; c++) b[c] && a.wrapper.prepend(b[c]);
            c = a.activeIndex + b.length
          } else a.wrapper.prepend(b);
          a.params.loop && a.createLoop();
          a.params.observer &&
            a.support.observer || a.update(!0);
          a.slideTo(c, 0, !1)
        }, a.removeSlide = function(b) {
          a.params.loop && (a.destroyLoop(), a.slides = a.wrapper.children("." + a.params.slideClass));
          var c = a.activeIndex;
          if ("object" == typeof b && b.length)
            for (var d = 0; d < b.length; d++) {
              var e = b[d];
              a.slides[e] && a.slides.eq(e).remove();
              c > e && c--
            } else e = b, a.slides[e] && a.slides.eq(e).remove(), c > e && c--;
          c = Math.max(c, 0);
          a.params.loop && a.createLoop();
          a.params.observer && a.support.observer || a.update(!0);
          a.params.loop ? a.slideTo(c + a.loopedSlides, 0, !1) :
            a.slideTo(c, 0, !1)
        }, a.removeAllSlides = function() {
          for (var b = [], c = 0; c < a.slides.length; c++) b.push(c);
          a.removeSlide(b)
        }, a.effects = {
          fade: {
            setTranslate: function() {
              for (var b = 0; b < a.slides.length; b++) {
                var c = a.slides.eq(b),
                  d = -c[0].swiperSlideOffset;
                a.params.virtualTranslate || (d -= a.translate);
                var f = 0;
                e() || (f = d, d = 0);
                c.css({
                  opacity: a.params.fade.crossFade ? Math.max(1 - Math.abs(c[0].progress), 0) : 1 + Math.min(Math.max(c[0].progress, -1), 0)
                }).transform("translate3d(" + d + "px, " + f + "px, 0px)")
              }
            },
            setTransition: function(b) {
              if (a.slides.transition(b),
                a.params.virtualTranslate && 0 !== b) {
                var c = !1;
                a.slides.transitionEnd(function() {
                  if (!c && a) {
                    c = !0;
                    a.animating = !1;
                    for (var b = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], d = 0; d < b.length; d++) a.wrapper.trigger(b[d])
                  }
                })
              }
            }
          },
          cube: {
            setTranslate: function() {
              var b, c = 0;
              a.params.cube.shadow && (e() ? (b = a.wrapper.find(".swiper-cube-shadow"), 0 === b.length && (b = g('<div class="swiper-cube-shadow"></div>'), a.wrapper.append(b)), b.css({
                height: a.width + "px"
              })) : (b = a.container.find(".swiper-cube-shadow"),
                0 === b.length && (b = g('<div class="swiper-cube-shadow"></div>'), a.container.append(b))));
              for (var d = 0; d < a.slides.length; d++) {
                var f = a.slides.eq(d),
                  h = 90 * d,
                  l = Math.floor(h / 360);
                a.rtl && (h = -h, l = Math.floor(-h / 360));
                var r = Math.max(Math.min(f[0].progress, 1), -1),
                  t = 0,
                  m = 0,
                  n = 0;
                0 === d % 4 ? (t = 4 * -l * a.size, n = 0) : 0 === (d - 1) % 4 ? (t = 0, n = 4 * -l * a.size) : 0 === (d - 2) % 4 ? (t = a.size + 4 * l * a.size, n = a.size) : 0 === (d - 3) % 4 && (t = -a.size, n = 3 * a.size + 4 * a.size * l);
                a.rtl && (t = -t);
                e() || (m = t, t = 0);
                h = "rotateX(" + (e() ? 0 : -h) + "deg) rotateY(" + (e() ? h : 0) + "deg) translate3d(" +
                  t + "px, " + m + "px, " + n + "px)";
                if (1 >= r && -1 < r && (c = 90 * d + 90 * r, a.rtl && (c = 90 * -d - 90 * r)), f.transform(h), a.params.cube.slideShadows) r = f.find(e() ? ".swiper-slide-shadow-left" : ".swiper-slide-shadow-top"), h = f.find(e() ? ".swiper-slide-shadow-right" : ".swiper-slide-shadow-bottom"), 0 === r.length && (r = g('<div class="swiper-slide-shadow-' + (e() ? "left" : "top") + '"></div>'), f.append(r)), 0 === h.length && (h = g('<div class="swiper-slide-shadow-' + (e() ? "right" : "bottom") + '"></div>'), f.append(h)), f[0].progress, r.length && (r[0].style.opacity = -f[0].progress), h.length && (h[0].style.opacity = f[0].progress)
              }
              if (a.wrapper.css({
                  "-webkit-transform-origin": "50% 50% -" + a.size / 2 + "px",
                  "-moz-transform-origin": "50% 50% -" + a.size / 2 + "px",
                  "-ms-transform-origin": "50% 50% -" + a.size / 2 + "px",
                  "transform-origin": "50% 50% -" + a.size / 2 + "px"
                }), a.params.cube.shadow) e() ? b.transform("translate3d(0px, " + (a.width / 2 + a.params.cube.shadowOffset) + "px, " + -a.width / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + a.params.cube.shadowScale + ")") : (d = Math.abs(c) - 90 * Math.floor(Math.abs(c) /
                90), d = a.params.cube.shadowScale / (1.5 - (Math.sin(2 * d * Math.PI / 360) / 2 + Math.cos(2 * d * Math.PI / 360) / 2)), b.transform("scale3d(" + a.params.cube.shadowScale + ", 1, " + d + ") translate3d(0px, " + (a.height / 2 + a.params.cube.shadowOffset) + "px, " + -a.height / 2 / d + "px) rotateX(-90deg)"));
              a.wrapper.transform("translate3d(0px,0," + (a.isSafari || a.isUiWebView ? -a.size / 2 : 0) + "px) rotateX(" + (e() ? 0 : c) + "deg) rotateY(" + (e() ? -c : 0) + "deg)")
            },
            setTransition: function(b) {
              a.slides.transition(b).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(b);
              a.params.cube.shadow && !e() && a.container.find(".swiper-cube-shadow").transition(b)
            }
          },
          coverflow: {
            setTranslate: function() {
              var b = a.translate;
              b = e() ? -b + a.width / 2 : -b + a.height / 2;
              for (var c = e() ? a.params.coverflow.rotate : -a.params.coverflow.rotate, d = a.params.coverflow.depth, f = 0, h = a.slides.length; h > f; f++) {
                var l = a.slides.eq(f),
                  r = a.slidesSizesGrid[f];
                r = (b - l[0].swiperSlideOffset - r / 2) / r * a.params.coverflow.modifier;
                var t = e() ? c * r : 0,
                  m = e() ? 0 : c * r,
                  n = -d * Math.abs(r),
                  q = e() ? 0 : a.params.coverflow.stretch * r,
                  p = e() ? a.params.coverflow.stretch *
                  r : 0;
                .001 > Math.abs(p) && (p = 0);
                .001 > Math.abs(q) && (q = 0);
                .001 > Math.abs(n) && (n = 0);
                .001 > Math.abs(t) && (t = 0);
                .001 > Math.abs(m) && (m = 0);
                if (l.transform("translate3d(" + p + "px," + q + "px," + n + "px)  rotateX(" + m + "deg) rotateY(" + t + "deg)"), l[0].style.zIndex = -Math.abs(Math.round(r)) + 1, a.params.coverflow.slideShadows) t = l.find(e() ? ".swiper-slide-shadow-left" : ".swiper-slide-shadow-top"), m = l.find(e() ? ".swiper-slide-shadow-right" : ".swiper-slide-shadow-bottom"), 0 === t.length && (t = g('<div class="swiper-slide-shadow-' + (e() ? "left" :
                  "top") + '"></div>'), l.append(t)), 0 === m.length && (m = g('<div class="swiper-slide-shadow-' + (e() ? "right" : "bottom") + '"></div>'), l.append(m)), t.length && (t[0].style.opacity = 0 < r ? r : 0), m.length && (m[0].style.opacity = 0 < -r ? -r : 0)
              }
              a.browser.ie && (a.wrapper[0].style.perspectiveOrigin = b + "px 50%")
            },
            setTransition: function(b) {
              a.slides.transition(b).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(b)
            }
          }
        }, a.lazy = {
          initialImageLoaded: !1,
          loadImageInSlide: function(b,
            c) {
            if ("undefined" != typeof b && ("undefined" == typeof c && (c = !0), 0 !== a.slides.length)) {
              var d = a.slides.eq(b);
              b = d.find(".swiper-lazy:not(.swiper-lazy-loaded):not(.swiper-lazy-loading)");
              !d.hasClass("swiper-lazy") || d.hasClass("swiper-lazy-loaded") || d.hasClass("swiper-lazy-loading") || b.add(d[0]);
              0 !== b.length && b.each(function() {
                var b = g(this);
                b.addClass("swiper-lazy-loading");
                var e = b.attr("data-background"),
                  f = b.attr("data-src");
                a.loadImage(b[0], f || e, !1, function() {
                  if (e ? (b.css("background-image", "url(" + e + ")"),
                      b.removeAttr("data-background")) : (b.attr("src", f), b.removeAttr("data-src")), b.addClass("swiper-lazy-loaded").removeClass("swiper-lazy-loading"), d.find(".swiper-lazy-preloader, .preloader").remove(), a.params.loop && c) {
                    var h = d.attr("data-swiper-slide-index");
                    d.hasClass(a.params.slideDuplicateClass) ? (h = a.wrapper.children('[data-swiper-slide-index="' + h + '"]:not(.' + a.params.slideDuplicateClass + ")"), a.lazy.loadImageInSlide(h.index(), !1)) : (h = a.wrapper.children("." + a.params.slideDuplicateClass + '[data-swiper-slide-index="' +
                      h + '"]'), a.lazy.loadImageInSlide(h.index(), !1))
                  }
                  a.emit("onLazyImageReady", a, d[0], b[0])
                });
                a.emit("onLazyImageLoad", a, d[0], b[0])
              })
            }
          },
          load: function() {
            var b;
            if (a.params.watchSlidesVisibility) a.wrapper.children("." + a.params.slideVisibleClass).each(function() {
              a.lazy.loadImageInSlide(g(this).index())
            });
            else if (1 < a.params.slidesPerView)
              for (b = a.activeIndex; b < a.activeIndex + a.params.slidesPerView; b++) a.slides[b] && a.lazy.loadImageInSlide(b);
            else a.lazy.loadImageInSlide(a.activeIndex);
            if (a.params.lazyLoadingInPrevNext)
              if (1 <
                a.params.slidesPerView) {
                for (b = a.activeIndex + a.params.slidesPerView; b < a.activeIndex + a.params.slidesPerView + a.params.slidesPerView; b++) a.slides[b] && a.lazy.loadImageInSlide(b);
                for (b = a.activeIndex - a.params.slidesPerView; b < a.activeIndex; b++) a.slides[b] && a.lazy.loadImageInSlide(b)
              } else b = a.wrapper.children("." + a.params.slideNextClass), 0 < b.length && a.lazy.loadImageInSlide(b.index()), b = a.wrapper.children("." + a.params.slidePrevClass), 0 < b.length && a.lazy.loadImageInSlide(b.index())
          },
          onTransitionStart: function() {
            a.params.lazyLoading &&
              (a.params.lazyLoadingOnTransitionStart || !a.params.lazyLoadingOnTransitionStart && !a.lazy.initialImageLoaded) && a.lazy.load()
          },
          onTransitionEnd: function() {
            a.params.lazyLoading && !a.params.lazyLoadingOnTransitionStart && a.lazy.load()
          }
        }, a.scrollbar = {
          set: function() {
            if (a.params.scrollbar) {
              var b = a.scrollbar;
              b.track = g(a.params.scrollbar);
              b.drag = b.track.find(".swiper-scrollbar-drag");
              0 === b.drag.length && (b.drag = g('<div class="swiper-scrollbar-drag"></div>'), b.track.append(b.drag));
              b.drag[0].style.width = "";
              b.drag[0].style.height =
                "";
              b.trackSize = e() ? b.track[0].offsetWidth : b.track[0].offsetHeight;
              b.divider = a.size / a.virtualSize;
              b.moveDivider = b.trackSize / a.size * b.divider;
              b.dragSize = b.trackSize * b.divider;
              e() ? b.drag[0].style.width = b.dragSize + "px" : b.drag[0].style.height = b.dragSize + "px";
              b.track[0].style.display = 1 <= b.divider ? "none" : "";
              a.params.scrollbarHide && (b.track[0].style.opacity = 0)
            }
          },
          setTranslate: function() {
            if (a.params.scrollbar) {
              var b = a.scrollbar,
                c = (a.translate || 0, b.dragSize);
              var d = (b.trackSize - b.dragSize) * a.progress;
              a.rtl &&
                e() ? (d = -d, 0 < d ? (c = b.dragSize - d, d = 0) : -d + b.dragSize > b.trackSize && (c = b.trackSize + d)) : 0 > d ? (c = b.dragSize + d, d = 0) : d + b.dragSize > b.trackSize && (c = b.trackSize - d);
              e() ? (b.drag.transform(a.support.transforms3d ? "translate3d(" + d + "px, 0, 0)" : "translateX(" + d + "px)"), b.drag[0].style.width = c + "px") : (b.drag.transform(a.support.transforms3d ? "translate3d(0px, " + d + "px, 0)" : "translateY(" + d + "px)"), b.drag[0].style.height = c + "px");
              a.params.scrollbarHide && (clearTimeout(b.timeout), b.track[0].style.opacity = 1, b.timeout = setTimeout(function() {
                b.track[0].style.opacity =
                  0;
                b.track.transition(400)
              }, 1E3))
            }
          },
          setTransition: function(b) {
            a.params.scrollbar && a.scrollbar.drag.transition(b)
          }
        }, a.controller = {
          LinearSpline: function(a, b) {
            this.x = a;
            this.y = b;
            this.lastIndex = a.length - 1;
            var c, d;
            this.x.length;
            this.interpolate = function(a) {
              return a ? (d = e(this.x, a), c = d - 1, (a - this.x[c]) * (this.y[d] - this.y[c]) / (this.x[d] - this.x[c]) + this.y[c]) : 0
            };
            var e = function() {
              var a, b, c;
              return function(d, e) {
                b = -1;
                for (a = d.length; 1 < a - b;) d[c = a + b >> 1] <= e ? b = c : a = c;
                return a
              }
            }()
          },
          getInterpolateFunction: function(b) {
            a.controller.spline ||
              (a.controller.spline = a.params.loop ? new a.controller.LinearSpline(a.slidesGrid, b.slidesGrid) : new a.controller.LinearSpline(a.snapGrid, b.snapGrid))
          },
          setTranslate: function(b, c) {
            function d(c) {
              b = c.rtl && "horizontal" === c.params.direction ? -a.translate : a.translate;
              "slide" === a.params.controlBy && (a.controller.getInterpolateFunction(c), f = -a.controller.spline.interpolate(-b));
              f && "container" !== a.params.controlBy || (e = (c.maxTranslate() - c.minTranslate()) / (a.maxTranslate() - a.minTranslate()), f = (b - a.minTranslate()) *
                e + c.minTranslate());
              a.params.controlInverse && (f = c.maxTranslate() - f);
              c.updateProgress(f);
              c.setWrapperTranslate(f, !1, a);
              c.updateActiveIndex()
            }
            var e, f, g = a.params.control;
            if (a.isArray(g))
              for (var k = 0; k < g.length; k++) g[k] !== c && g[k] instanceof h && d(g[k]);
            else g instanceof h && c !== g && d(g)
          },
          setTransition: function(b, c) {
            function d(c) {
              c.setWrapperTransition(b, a);
              0 !== b && (c.onTransitionStart(), c.wrapper.transitionEnd(function() {
                f && (c.params.loop && "slide" === a.params.controlBy && c.fixLoop(), c.onTransitionEnd())
              }))
            }
            var e,
              f = a.params.control;
            if (a.isArray(f))
              for (e = 0; e < f.length; e++) f[e] !== c && f[e] instanceof h && d(f[e]);
            else f instanceof h && c !== f && d(f)
          }
        }, a.hashnav = {
          init: function() {
            if (a.params.hashnav) {
              a.hashnav.initialized = !0;
              var b = document.location.hash.replace("#", "");
              if (b)
                for (var c = 0, d = a.slides.length; d > c; c++) {
                  var e = a.slides.eq(c);
                  e.attr("data-hash") !== b || e.hasClass(a.params.slideDuplicateClass) || (e = e.index(), a.slideTo(e, 0, a.params.runCallbacksOnInit, !0))
                }
            }
          },
          setHash: function() {
            a.hashnav.initialized && a.params.hashnav &&
              (document.location.hash = a.slides.eq(a.activeIndex).attr("data-hash") || "")
          }
        }, a.disableKeyboardControl = function() {
          g(document).off("keydown", C)
        }, a.enableKeyboardControl = function() {
          g(document).on("keydown", C)
        }, a.mousewheel = {
          event: !1,
          lastScrollTime: (new window.Date).getTime()
        }, a.params.mousewheelControl) {
        if (void 0 !== document.onmousewheel && (a.mousewheel.event = "mousewheel"), !a.mousewheel.event) try {
          new window.WheelEvent("wheel"), a.mousewheel.event = "wheel"
        } catch (k) {}
        a.mousewheel.event || (a.mousewheel.event =
          "DOMMouseScroll")
      }
      a.disableMousewheelControl = function() {
        return a.mousewheel.event ? (a.container.off(a.mousewheel.event, y), !0) : !1
      };
      a.enableMousewheelControl = function() {
        return a.mousewheel.event ? (a.container.on(a.mousewheel.event, y), !0) : !1
      };
      a.parallax = {
        setTranslate: function() {
          a.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function() {
            B(this, a.progress)
          });
          a.slides.each(function() {
            var a = g(this);
            a.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function() {
              B(this,
                Math.min(Math.max(a[0].progress, -1), 1))
            })
          })
        },
        setTransition: function(b) {
          "undefined" == typeof b && (b = a.params.speed);
          a.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function() {
            var a = g(this),
              c = parseInt(a.attr("data-swiper-parallax-duration"), 10) || b;
            0 === b && (c = 0);
            a.transition(c)
          })
        }
      };
      a._plugins = [];
      for (var P in a.plugins)(b = a.plugins[P](a, a.params[P])) && a._plugins.push(b);
      return a.callPlugins = function(b, c, d, e, f, h) {
        for (var g = 0; g < a._plugins.length; g++) b in
          a._plugins[g] && a._plugins[g][b](c, d, e, f, h)
      }, a.emitterEventListeners = {}, a.emit = function(b, c, d, e, f, h) {
        a.params[b] && a.params[b](c, d, e, f, h);
        var g;
        if (a.emitterEventListeners[b])
          for (g = 0; g < a.emitterEventListeners[b].length; g++) a.emitterEventListeners[b][g](c, d, e, f, h);
        a.callPlugins && a.callPlugins(b, c, d, e, f, h)
      }, a.on = function(b, c) {
        return b = M(b), a.emitterEventListeners[b] || (a.emitterEventListeners[b] = []), a.emitterEventListeners[b].push(c), a
      }, a.off = function(b, c) {
        var d;
        if (b = M(b), "undefined" == typeof c) return a.emitterEventListeners[b] = [], a;
        if (a.emitterEventListeners[b] && 0 !== a.emitterEventListeners[b].length) {
          for (d = 0; d < a.emitterEventListeners[b].length; d++) a.emitterEventListeners[b][d] === c && a.emitterEventListeners[b].splice(d, 1);
          return a
        }
      }, a.once = function(b, c) {
        b = M(b);
        var d = function(e, f, h, g, k) {
          c(e, f, h, g, k);
          a.off(b, d)
        };
        return a.on(b, d), a
      }, a.a11y = {
        makeFocusable: function(a) {
          return a.attr("tabIndex", "0"), a
        },
        addRole: function(a, b) {
          return a.attr("role", b), a
        },
        addLabel: function(a, b) {
          return a.attr("aria-label", b), a
        },
        disable: function(a) {
          return a.attr("aria-disabled",
            !0), a
        },
        enable: function(a) {
          return a.attr("aria-disabled", !1), a
        },
        onEnterKey: function(b) {
          13 === b.keyCode && (g(b.target).is(a.params.nextButton) ? (a.onClickNext(b), a.a11y.notify(a.isEnd ? a.params.lastSlideMessage : a.params.nextSlideMessage)) : g(b.target).is(a.params.prevButton) && (a.onClickPrev(b), a.a11y.notify(a.isBeginning ? a.params.firstSlideMessage : a.params.prevSlideMessage)), g(b.target).is("." + a.params.bulletClass) && g(b.target)[0].click())
        },
        liveRegion: g('<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>'),
        notify: function(b) {
          var c = a.a11y.liveRegion;
          0 !== c.length && (c.html(""), c.html(b))
        },
        init: function() {
          if (a.params.nextButton) {
            var b = g(a.params.nextButton);
            a.a11y.makeFocusable(b);
            a.a11y.addRole(b, "button");
            a.a11y.addLabel(b, a.params.nextSlideMessage)
          }
          a.params.prevButton && (b = g(a.params.prevButton), a.a11y.makeFocusable(b), a.a11y.addRole(b, "button"), a.a11y.addLabel(b, a.params.prevSlideMessage));
          g(a.container).append(a.a11y.liveRegion)
        },
        initPagination: function() {
          a.params.pagination && a.params.paginationClickable &&
            a.bullets && a.bullets.length && a.bullets.each(function() {
              var b = g(this);
              a.a11y.makeFocusable(b);
              a.a11y.addRole(b, "button");
              a.a11y.addLabel(b, a.params.paginationBulletMessage.replace(/{{index}}/, b.index() + 1))
            })
        },
        destroy: function() {
          a.a11y.liveRegion && 0 < a.a11y.liveRegion.length && a.a11y.liveRegion.remove()
        }
      }, a.init = function() {
        a.params.loop && a.createLoop();
        a.updateContainerSize();
        a.updateSlidesSize();
        a.updatePagination();
        a.params.scrollbar && a.scrollbar && a.scrollbar.set();
        "slide" !== a.params.effect && a.effects[a.params.effect] &&
          (a.params.loop || a.updateProgress(), a.effects[a.params.effect].setTranslate());
        a.params.loop ? a.slideTo(a.params.initialSlide + a.loopedSlides, 0, a.params.runCallbacksOnInit) : (a.slideTo(a.params.initialSlide, 0, a.params.runCallbacksOnInit), 0 === a.params.initialSlide && (a.parallax && a.params.parallax && a.parallax.setTranslate(), a.lazy && a.params.lazyLoading && (a.lazy.load(), a.lazy.initialImageLoaded = !0)));
        a.attachEvents();
        a.params.observer && a.support.observer && a.initObservers();
        a.params.preloadImages && !a.params.lazyLoading &&
          a.preloadImages();
        a.params.autoplay && a.startAutoplay();
        a.params.keyboardControl && a.enableKeyboardControl && a.enableKeyboardControl();
        a.params.mousewheelControl && a.enableMousewheelControl && a.enableMousewheelControl();
        a.params.hashnav && a.hashnav && a.hashnav.init();
        a.params.a11y && a.a11y && a.a11y.init();
        a.emit("onInit", a)
      }, a.cleanupStyles = function() {
        a.container.removeClass(a.classNames.join(" ")).removeAttr("style");
        a.wrapper.removeAttr("style");
        a.slides && a.slides.length && a.slides.removeClass([a.params.slideVisibleClass,
          a.params.slideActiveClass, a.params.slideNextClass, a.params.slidePrevClass
        ].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row");
        a.paginationContainer && a.paginationContainer.length && a.paginationContainer.removeClass(a.params.paginationHiddenClass);
        a.bullets && a.bullets.length && a.bullets.removeClass(a.params.bulletActiveClass);
        a.params.prevButton && g(a.params.prevButton).removeClass(a.params.buttonDisabledClass);
        a.params.nextButton && g(a.params.nextButton).removeClass(a.params.buttonDisabledClass);
        a.params.scrollbar && a.scrollbar && (a.scrollbar.track && a.scrollbar.track.length && a.scrollbar.track.removeAttr("style"), a.scrollbar.drag && a.scrollbar.drag.length && a.scrollbar.drag.removeAttr("style"))
      }, a.destroy = function(b, c) {
        a.detachEvents();
        a.stopAutoplay();
        a.params.loop && a.destroyLoop();
        c && a.cleanupStyles();
        a.disconnectObservers();
        a.params.keyboardControl && a.disableKeyboardControl && a.disableKeyboardControl();
        a.params.mousewheelControl && a.disableMousewheelControl && a.disableMousewheelControl();
        a.params.a11y &&
          a.a11y && a.a11y.destroy();
        a.emit("onDestroy");
        !1 !== b && (a = null)
      }, a.init(), a
    }
  };
  h.prototype = {
    isSafari: function() {
      var b = navigator.userAgent.toLowerCase();
      return 0 <= b.indexOf("safari") && 0 > b.indexOf("chrome") && 0 > b.indexOf("android")
    }(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent),
    isArray: function(b) {
      return "[object Array]" === Object.prototype.toString.apply(b)
    },
    browser: {
      ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
      ieTouch: window.navigator.msPointerEnabled &&
        1 < window.navigator.msMaxTouchPoints || window.navigator.pointerEnabled && 1 < window.navigator.maxTouchPoints
    },
    device: function() {
      var b = navigator.userAgent,
        c = b.match(/(Android);?[\s\/]+([\d.]+)?/),
        e = b.match(/(iPad).*OS\s([\d_]+)/),
        f = b.match(/(iPod)(.*OS\s([\d_]+))?/);
      b = !e && b.match(/(iPhone\sOS)\s([\d_]+)/);
      return {
        ios: e || b || f,
        android: c
      }
    }(),
    support: {
      touch: window.Modernizr && !0 === Modernizr.touch || !!("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch),
      transforms3d: window.Modernizr &&
        !0 === Modernizr.csstransforms3d || function() {
          var b = document.createElement("div").style;
          return "webkitPerspective" in b || "MozPerspective" in b || "OPerspective" in b || "MsPerspective" in b || "perspective" in b
        }(),
      flexbox: function() {
        for (var b = document.createElement("div").style, c = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), e = 0; e < c.length; e++)
          if (c[e] in b) return !0
      }(),
      observer: "MutationObserver" in
        window || "WebkitMutationObserver" in window
    },
    plugins: {}
  };
  for (var f = ["jQuery", "Zepto", "Dom7"], c = 0; c < f.length; c++) window[f[c]] && b(window[f[c]]);
  (f = "undefined" == typeof Dom7 ? window.Dom7 || window.Zepto || window.jQuery : Dom7) && ("transitionEnd" in f.fn || (f.fn.transitionEnd = function(b) {
    function c(e) {
      if (e.target === this)
        for (b.call(this, e), d = 0; d < f.length; d++) h.off(f[d], c)
    }
    var d, f = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
      h = this;
    if (b)
      for (d = 0; d < f.length; d++) h.on(f[d],
        c);
    return this
  }), "transform" in f.fn || (f.fn.transform = function(b) {
    for (var c = 0; c < this.length; c++) {
      var d = this[c].style;
      d.webkitTransform = d.MsTransform = d.msTransform = d.MozTransform = d.OTransform = d.transform = b
    }
    return this
  }), "transition" in f.fn || (f.fn.transition = function(b) {
    "string" != typeof b && (b += "ms");
    for (var c = 0; c < this.length; c++) {
      var d = this[c].style;
      d.webkitTransitionDuration = d.MsTransitionDuration = d.msTransitionDuration = d.MozTransitionDuration = d.OTransitionDuration = d.transitionDuration = b
    }
    return this
  }));
  window.Swiper = h
}();
"undefined" != typeof module ? module.exports = window.Swiper : "function" == typeof define && define.amd && define([], function() {
  return window.Swiper
});

function replaceUrlParam(b, g, h) {
  var f = b.replace(new RegExp("(" + g + "=).*?(&|$)"), "$1" + h + "$2");
  f == b && (f = f + (0 < f.indexOf("?") ? "&" : "?") + g + "=" + h);
  return f
}
window.timber = window.timber || {};
timber.cacheSelectors = function() {
  timber.cache = {
    $html: $("html"),
    $body: $("body"),
    $navigation: $("#AccessibleNav"),
    $changeView: $(".change-view"),
    $productImageWrap: $("#ProductPhoto"),
    $productImage: $("#ProductPhotoImg"),
    $thumbImages: $("#ProductThumbs").find("a.product-single__thumbnail")
  }
};
timber.init = function() {
  // FastClick disabled for Storefront 1.0.
// Modern browsers provide native fast taps.
// Remove the FastClick library when legacy JavaScript is eliminated.
// FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.autoResponsiveElements();
  timber.collectionViews();
  timber.productImageZoom()
};
timber.accessibleNav = function() {
  function b(b) {
    b.addClass("nav-hover");
    setTimeout(function() {
      timber.cache.$body.on("touchstart", function() {
        g(b)
      })
    }, 250)
  }

  function g(b) {
    b.removeClass("nav-hover");
    timber.cache.$body.off("touchstart")
  }
  var h = timber.cache.$navigation,
    f = h.find("a"),
    c = h.children("li").find("a"),
    d = h.find(".site-nav--has-dropdown");
  h = h.find(".site-nav__dropdown").find("a");
  d.on("mouseenter touchstart", function(c) {
    var d = $(this);
    d.hasClass("nav-hover") || c.preventDefault();
    b(d)
  });
  d.on("mouseleave",
    function() {
      g($(this))
    });
  h.on("touchstart", function(b) {
    b.stopImmediatePropagation()
  });
  f.focus(function() {
    var b = $(this);
    b.next("ul").hasClass("sub-nav");
    $(".site-nav__dropdown").has(b).length ? (b = b.closest(".site-nav--has-dropdown").find("a"), b.addClass("nav-focus")) : (c.removeClass("nav-focus"), b.addClass("nav-focus"))
  });
  f.blur(function() {
    c.removeClass("nav-focus")
  })
};
timber.productPage = function(b) {
  var g = b.money_format;
  b = b.variant;
  var h = $("#ProductPhotoImg"),
    f = $("#AddToCart"),
    c = $("#ProductPrice"),
    d = $("#ComparePrice"),
    l = $(".quantity-selector, label + .js-qty"),
    e = $("#AddToCartText");
  b ? (b.featured_image && Shopify.Image.switchImage(b.featured_image, h[0], timber.switchImage), b.available ? (f.removeClass("disabled").prop("disabled", !1), e.html("Add to Cart"), l.show()) : (f.addClass("disabled").prop("disabled", !0), e.html("Sold Out"), l.hide()), c.html(Shopify.formatMoney(b.price,
    g)), b.compare_at_price > b.price ? d.html(Shopify.formatMoney(b.compare_at_price, g)).show() : d.hide()) : (f.addClass("disabled").prop("disabled", !0), e.html("Unavailable"), l.hide())
};
timber.productImageSwitch = function() {
  if (timber.cache.$thumbImages.length) timber.cache.$thumbImages.on("click", function(b) {
    b.preventDefault();
    b = $(this).attr("href");
    timber.switchImage(b, null, timber.cache.$productImage)
  })
};
timber.switchImage = function(b, g, h) {
  var $h = $(h);
  $h.attr('srcset', '');
  $h.attr("src", b)
};
timber.autoResponsiveElements = function() {
  $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
  $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
  $("iframe").each(function() {
    this.src = this.src
  })
};
timber.collectionViews = function() {
  if (timber.cache.$changeView.length) timber.cache.$changeView.on("click", function() {
    var b = $(this).data("view"),
      g = document.URL; - 1 < g.indexOf("?") ? window.location = replaceUrlParam(g, "view", b) : window.location = g + "?view=" + b
  })
};
timber.productImageZoom = function() {};
$(timber.init);
! function(b) {
  b.fn.equalHeights = function() {
    var g = 0,
      h = b(this);
    return h.each(function() {
      var f = b(this).innerHeight();
      f > g && (g = f)
    }), h.css("height", g)
  };
  b("[data-equal]").each(function() {
    var g = b(this),
      h = g.data("equal");
    g.find(h).equalHeights()
  })
}(jQuery);
var afterResize = function() {
  var b = {};
  return function(g, h, f) {
    f || (f = "Don't call this twice without a uniqueId");
    b[f] && clearTimeout(b[f]);
    b[f] = setTimeout(g, h)
  }
}();
window.expo = window.expo || {};

/* ============================================================
   BEDZ KING CORE UI MODULES

   STATUS:
   Migration in Progress

   Replacement File:
   assets/main.v2.05.js

   MIGRATED MODULES
   ✓ Header Search
   ✓ Header Menu
   ✓ Menu Accordion
   ✓ Sidebar Dropdowns
   ✓ Footer Navigation
   ✓ Product Tab Switcher
   ✓ Homepage Promo Products
   ✓ Mobile Collection Refine / Sort

   REVIEWED / OBSOLETE
   ✓ Equal Heights
   ✓ afterResize
   ✓ Expo Mobile Navigation

   REMAINING MODULES
   • Cart Controls
   • Product Gallery (Swiper)
   • Product Quantity Controls
   • Mattress Add-to-Cart
   • Product-specific JavaScript

   REMOVAL STRATEGY
   Modules are first migrated to main.v2.05.js,
   then disabled in this file, tested on desktop
   and mobile, and finally removed after
   successful verification.

   CURRENT VERSION:
   v2.05.010

   July 2026
============================================================ */

expo.cacheSelectors = function() {
  expo.cache = {
    $w: $(window),
    $body: $("body"),
    $tabTrigger: $(".tab-switch__trigger"),
    $tabContent: $(".tab-switch__content"),
    $mobileNavTrigger: $("#MobileNavTrigger"),
    $mobileNav: $("#MobileNav"),
    $mobileSublistTrigger: $(".mobile-nav__sublist-trigger"),
    $productGridImages: $(".grid-link__image--product"),
    $featuredGridImages: $(".grid-link__image--collection"),
    $sidebarDropdown: $(".sidebar-sublist"),
    $sidebarDropdownExpand: $(".sidebar-sublist__expand"),
    $sidebarDropdownContract: $(".sidebar-sublist__contract"),
    $sidebarSubLists: $(".sidebar-sublist__content"),
    $sidebarViewMore: $(".sidebar-module__viewmore"),
    cartNoteAdd: ".cart__note-add",
    cartNote: ".cart__note"
  }
};

expo.init = function() {
  expo.cacheSelectors();
  expo.mobileNav();
  expo.cartPage()
};

expo.mobileNav = function() {
  $(document)
    .off("click.expoMobileNav", "#MobileNavTrigger")
    .on("click.expoMobileNav", "#MobileNavTrigger", function(b) {
      b.preventDefault();
      $("#MobileNav").slideToggle(220);
    });

  $(document)
    .off("click.expoMobileSublist", ".mobile-nav__sublist-trigger")
    .on("click.expoMobileSublist", ".mobile-nav__sublist-trigger", function(b) {
      b.preventDefault();
      $(this).toggleClass("is-active").next(".mobile-nav__sublist").slideToggle(200);
    });
};

expo.cartPage = function() {};
$(expo.init);
window.mySwiper = null;
/* ==========================================================
   DISABLED IN v2.05.011

   Module:
   Header Search

   Replaced By:
   main.v2.05.js
   initBedzHeaderButtons()

   Status:
   ✓ Verified Desktop
   ✓ Verified Mobile

   Date:
   July 8, 2026

----------------------------------------------------------

$(".search-btn").on("click", function(b) {
  var f = $("#search-container");
  f.toggleClass("hide");
  $(b.currentTarget).toggleClass("_open");
  f.find('input[type="search"]').focus();
});

========================================================== */
$(function() {
  /* ==========================================================
   DISABLED IN v2.05.011
   Replaced by: main.v2.05.js (initBedzHeaderButtons)
   Verified: Desktop + Mobile
   Date: July 2026
==========================================================

$(".search-btn").on("click", function(b) {
  var f = $("#search-container");
  f.toggleClass("hide");
  $(b.currentTarget).toggleClass("_open");
  f.find('input[type="search"]').focus();
});

========================================================== */

/* ==========================================================
   DISABLED IN v2.05.011

   Module:
   Header Menu

   Replaced By:
   main.v2.05.js
   initBedzHeaderButtons()

   Status:
   ✓ Verified Desktop
   ✓ Verified Mobile

   Date:
   July 8, 2026

----------------------------------------------------------

$(".menu-btn").on("click", function(b) {
    $("#menu-container").toggleClass("hide");
    $(b.currentTarget).toggleClass("_open")
});

========================================================== */
/* ==========================================================
   DISABLED IN v2.05.011

   Module:
   Homepage Promo Products

   Replaced By:
   main.v2.05.js
   initBedzHomepagePromoProducts()

   Status:
   Pending verification

   Date:
   July 2026

----------------------------------------------------------

var b = $("#_sale-items ul.products > li.hide");
if (0 < b.length) {
  hsi_idxs = [];
  for (var g = 0; g < b.length; g++) hsi_idxs.push(g);
  hsi_idxs = hsi_idxs.sort(function() {
    return .5 - Math.random()
  });
  hsi_idxs = hsi_idxs.slice(0, 6);
  for (g = 0; g < b.length; g++)
    -1 != hsi_idxs.indexOf(g) && $(b[g]).removeClass("hide")
}

========================================================== */

/* ==========================================================
   DISABLED IN v2.05.011

   Module:
   Mobile Collection Refine / Sort

   Replaced By:
   main.v2.05.js
   initBedzMobileCollectionRefineSort()

   Status:
   Pending verification

   Date:
   July 2026

----------------------------------------------------------

$("#mobile-refine-sort-btns > div").on("click", function(b) {
  $(b.currentTarget).hasClass("_open")
    ? (
        $(b.currentTarget).removeClass("_open"),
        $('#isp_container ul[data-btn-id="' + b.currentTarget.id + '"]').removeClass("_open")
      )
    : (
        $("#mobile-refine-sort-btns > div").not(b.currentTarget).removeClass("_open"),
        $(b.currentTarget).addClass("_open"),
        $('#isp_container ul[data-btn-id!="' + b.currentTarget.id + '"]').removeClass("_open"),
        $('#isp_container ul[data-btn-id="' + b.currentTarget.id + '"]').addClass("_open")
      );
});

========================================================== */
/* ============================================================
   BEDZ KING CART MODULES
   STATUS: REVIEW
   PURPOSE:
   Cart quantity controls, checkout agreement checkbox,
   and cart checkout button state.
   USED BY BEDZ KING:
   Yes
   ACTION:
   Review for migration to main.v2.xx.js.
   ============================================================ */

/* ============================================================
   BEDZ KING PRODUCT PAGE MODULES

   STATUS:
   Review / Partial Migration

   Replacement File:
   assets/main.v2.05.js

   MIGRATED
   ✓ Mobile Product Tabs

   REVIEWED / OBSOLETE
   ✓ View All Specs

   ACTIVE / KEEP FOR NOW
   ⚠ Product Quantity Controls
   ⚠ Mattress Add-to-Cart
   ⚠ Product Gallery / Swiper
   ⚠ Variant Image Switching

   ACTION:
Keep Product Quantity Controls, Mattress Add-to-Cart,
Product Gallery / Swiper, and Variant Image Switching
in the legacy file until migrated as one coordinated
product-page module.

   July 2026
============================================================ */


$("body.template-product").length && (
  1 < $(".swiper-container .swiper-slide").length
    ? "undefined" != typeof Swiper &&
      (
        window.mySwiper = new Swiper(".swiper-container", {
          direction: "horizontal",
          autoplay: "5000",
          loop: !0,
          nextButton: ".swiper-button-next",
          prevButton: ".swiper-button-prev",
          pagination: ".swiper-pagination"
        }),
        window.mySwiper.on("onSlideChangeEnd", function(b) {
          (b = b.slides[b.activeIndex]) &&
            variant_fix &&
            variant_fix.call(b)
        })
      )
    : $(".swiper-button-prev, .swiper-button-next").addClass("hide")
);


  $("body.template-product .mobile-tab").on("click", function(b) {
    $(b.currentTarget).next("div").toggleClass("hide");
    $(b.currentTarget).toggleClass("active");
    setTimeout(function() {
      window.scroll(0, $(b.currentTarget).offset().top)
    }, 100);
    return !1
  });
  $("body.template-product .view-all-specs").on("click",
    function(b) {
      $(".product-features-full").is(":visible") ? $(".product-features-full").click() : (b = $("#larger-tabs").offset().top, $("html, body").animate({
        scrollTop: b + "px"
      }, 250), $('.tab-switch__trigger:contains("Product Details")').not(".is-active").length && $('.tab-switch__trigger:contains("Product Details")').trigger("click"));
      return !1
    });

/* ==========================================================
   DISABLED IN v2.05.013

   Module:
   Mattress Add-to-Cart

   Replaced By:
   main.v2.05.js
   initBedzMattressAddToCart()

   Status:
   ✓ Verified Desktop
   ✓ Verified Mobile
   ✓ Correct variant and quantity
   ✓ Mattress visible on first cart load

   Date:
   July 2026

----------------------------------------------------------

$("._mattress-module .add-btn").on("click", function(event) {
  event.preventDefault();

  var button = $(event.currentTarget);
  var mattressItem = button.closest("._mattress-item");

  if (!button.hasClass("add-one")) {
    return false;
  }

  var variantId = mattressItem.attr("data-variant-id");
  var quantity = parseInt(
    button.closest(".table").find("input").val(),
    10
  ) || 1;

  var form = $("<form>", {
    method: "post",
    action: "/cart/add"
  });

  form.append(
    $("<input>", {
      type: "hidden",
      name: "id",
      value: variantId
    })
  );

  form.append(
    $("<input>", {
      type: "hidden",
      name: "quantity",
      value: quantity
    })
  );

  form.append(
    $("<input>", {
      type: "hidden",
      name: "return_to",
      value: "/cart"
    })
  );

  $("body").append(form);
  form.trigger("submit");

  return false;
});

========================================================== */


/* ==========================================================
   DISABLED IN v2.05.013

   Module:
   Product Quantity Controls

   Replaced By:
   main.v2.05.js
   initBedzProductQuantityControls()

   Status:
   ✓ Verified Desktop
   ✓ Verified Mobile
   ✓ Quantity cannot fall below 1
   ✓ Each mattress quantity operates independently

   Date:
   July 2026

----------------------------------------------------------

$(".fa-minus").on("click", function(b) {
  b = $(b.currentTarget).closest(".table").find("input");

  var f = b.val();

  if (1 < f) {
    f = parseInt(f, 10) - 1;
    b.val(f);

    if ("undefined" !== typeof b.attr("onkeyup")) {
      b.trigger("onkeyup");
    }
  }
});

$(".fa-plus").on("click", function(b) {
  b = $(b.currentTarget).closest(".table").find("input");

  var f = parseInt(b.val(), 10) || 0;

  b.val(f + 1);

  if ("undefined" !== typeof b.attr("onkeyup")) {
    b.trigger("onkeyup");
  }
});

========================================================== */


/* ==========================================================
   PRODUCT THUMBNAIL HOVER
   STATUS: ACTIVE LEGACY FIX
   ACTION: Keep until Product Gallery is fully migrated
========================================================== */

$("body.template-product").length && (
  $(".product-single__thumbnails a").on("mouseover", function(event) {
    var imageUrl = $(event.currentTarget).attr("href");

    if (imageUrl) {
      $("#ProductPhoto img").attr("src", imageUrl);
    }
  })
);
/* ============================================================
   BEDZ KING CHECKOUT HEADER PATCH
   STATUS: REVIEW
   PURPOSE:
   Removes homepage link from checkout logo.
   USED BY BEDZ KING:
   Yes
   ACTION:
   Review whether still needed before removal.
   ============================================================ */

  $("body.template-checkout div.main div.main__header a.logo").removeAttr("href");

/* ============================================================
   BEDZ KING PRODUCT BUTTON DISPLAY PATCH
   STATUS: REVIEW
   PURPOSE:
   Legacy display adjustment for pre-order and notify-me buttons.
   USED BY BEDZ KING:
   Unknown
   ACTION:
   Verify current button behavior before removal or migration.
   ============================================================ */

  setTimeout(function() {
    $("input#pre-order, input#notify-me", "body.template-product .add-to-cart-container").css("display", "inline-block !important");
    $("input#pre-order, input#notify-me", "body.template-product .add-to-cart-container").css("font-size",
      "12px !important")
  }, 100)
});

/* ============================================================
   BEDZ KING LEGACY UTILITY FUNCTIONS
   STATUS: REVIEW
   PURPOSE:
   Money formatting, cart checkout status,
   and dropdown helper functions.
   USED BY BEDZ KING:
   Mixed / Unknown
   ACTION:
   Review each helper before removal.
   ============================================================ */

var make_money = function(b) {
    return "$" + b
  },
  cart_checkout_button_status = function() {
    0 < $("body.template-cart #tac-agree input:checked").length ? ($("body.template-cart form.cart .checkout-btn").removeAttr("disabled"), $("body.template-cart .cart__additional_checkout input").removeAttr("disabled"), $("body.template-cart .cart__additional_checkout").fadeTo(1, 1)) : ($("body.template-cart form.cart .checkout-btn").attr("disabled", "disabled"), $("body.template-cart .cart__additional_checkout input").attr("disabled", "disabled"),
      $("body.template-cart .cart__additional_checkout").fadeTo(1, .6));
    return !1
  },
  _toggleDropdown = function(b, g) {
    $("ul.dropdown-menu", b).is(":visible") ? toggleDropdown(g, !1) : toggleDropdown(g, !0);
    return !1
  },
  _toggleDropdownSort = function(b) {
    $("#sorting_drop_list", b).is(":visible") ? toggleDropdownSort(!1) : toggleDropdownSort(!0);
    return !1
  };

/* ============================================================
   BEDZ KING SOCIAL / CONTACT MODULES
   STATUS: REVIEW
   PURPOSE:
   Social share link setup and contact popup behavior.
   USED BY BEDZ KING:
   Yes
   ACTION:
   Review for migration to main.v2.xx.js.
   ============================================================ */

$(document).ready(function() {
  $(".triggerContact").click(function(b) {
    b.preventDefault();
    $(".contact-popup").fadeIn(175)
  });
  $(".closeContact").click(function(b) {
    b.preventDefault();
    $(".contact-popup").fadeOut(175)
  });
  $(document).click(function(b) {
    b.target == $(".triggerContact")[0] || $(b.target).closest(".triggerContact").length || $(b.target).closest(".contact-popup-content").length || $(".contact-popup").fadeOut(175)
  })
});

/* ============================================================
   PASSIVE EVENT LISTENER OPTIMIZATION
   STATUS: KEEP
   PURPOSE:
   Improves scroll performance by defaulting selected
   touch, scroll, and wheel listeners to passive.
   USED BY BEDZ KING:
   Site-wide
   ACTION:
   Retain.
   ============================================================ */

(function() {
  var supportsPassive = eventListenerOptionsSupported();
  if (supportsPassive) {
    var addEvent = EventTarget.prototype.addEventListener;
    overwriteAddEvent(addEvent)
  }

  function overwriteAddEvent(superMethod) {
    var defaultOptions = {
      passive: true,
      capture: false
    };
    EventTarget.prototype.addEventListener = function(type, listener, options) {
      var usesListenerOptions = typeof options === "object";
      var useCapture = usesListenerOptions ? options.capture : options;
      options = usesListenerOptions ? options : {};
      if (type == "touchstart" || type == "scroll" || type == "wheel") options.passive = options.passive !== undefined ? options.passive : defaultOptions.passive;
      options.capture = useCapture !== undefined ? useCapture : defaultOptions.capture;
      superMethod.call(this, type, listener, options)
    }
  }

  function eventListenerOptionsSupported() {
    var supported = false;
    try {
      var opts = Object.defineProperty({}, "passive", {
        get: function() {
          supported = true
        }
      });
      window.addEventListener("test", null, opts)
    } catch (e) {}
    return supported
  }
})();